{
    "recruiting": "Recruiting",
    "courses": "Kurse",
    "courses-page": {
        "title": "Kurse",
        "create": "Kurs erstellen",
        "edit": "Kurs bearbeiten",
        "empty": "Noch keine Kurse",
        "fields": {
            "title": "Titel",
            "description": "Beschreibung",
            "documents-count": "Dokumente"
        },
        "headers": {
            "title": "Titel",
            "description": "Beschreibung",
            "documents": "Dokumente",
            "actions": "Aktionen"
        },
        "dialog": {
            "title-label": "Titel",
            "description-label": "Beschreibung",
            "documents-label": "Dokumente",
            "documents-placeholder": "Wissensdatenbank-Dokumente auswählen",
            "save": "Speichern",
            "cancel": "Abbrechen"
        },
        "messages": {
            "created": "Kurs erstellt",
            "updated": "Kurs aktualisiert",
            "deleted": "Kurs gelöscht",
            "error": "Etwas ist schiefgelaufen"
        },
        "confirm-delete": "Diesen Kurs löschen? Dies kann nicht rückgängig gemacht werden."
    },
    "ai-study-chat": "KI-Lernassistent",
    "ai-study-chat-page": {
        "title": "KI-Lernassistent",
        "new-conversation": "Neues Gespräch",
        "empty-sidebar": "Noch keine Gespräche",
        "empty-thread": "Wählen Sie einen Kurs oder ein Szenario, um mit dem Lernen zu beginnen",
        "untitled": "Neuer Chat",
        "input-placeholder": "Stellen Sie Ihre Frage…",
        "send": "Senden",
        "typing": "Assistent tippt…",
        "sources": "Quellen ({count})",
        "score": "Relevanz",
        "retry": "Erneut versuchen",
        "failed": "Senden fehlgeschlagen",
        "sources-label": "Quellen",
        "copy": "Kopieren",
        "copied": "Kopiert",
        "search-placeholder": "Gespräche durchsuchen",
        "search-empty": "Nichts gefunden",
        "empty": {
            "heading": "Bereit, beim Lernen zu helfen",
            "subtitle": "Stellen Sie beliebige Fragen zu den Kursmaterialien — ich finde die Antwort in der Wissensdatenbank und zeige die Quellen an."
        },
        "groups": {
            "today": "Heute",
            "yesterday": "Gestern",
            "earlier": "Früher"
        },
        "composer": {
            "context": "Kontext:",
            "hint": "Antworten werden von der KI aus Ihren Materialien generiert · Enter zum Senden, Shift+Enter für eine neue Zeile"
        },
        "suggestions-fallback": [
            {
                "title": "Materialien zusammenfassen",
                "subtitle": "Wichtigste Punkte"
            },
            {
                "title": "Lernplan erstellen",
                "subtitle": "Wo anfangen"
            },
            {
                "title": "Mich abfragen",
                "subtitle": "Schnelle Überprüfung"
            },
            {
                "title": "Einfach erklären",
                "subtitle": "Ohne Fachbegriffe"
            }
        ],
        "suggestions-fallback-debrief": [
            { "title": "Diese Sitzung auswerten", "subtitle": "Wichtigste Erkenntnisse" },
            { "title": "Was habe ich gut gemacht?", "subtitle": "Meine Stärken" },
            { "title": "Wo habe ich Fehler gemacht und warum?", "subtitle": "Wachstumspunkte" },
            { "title": "Was sollte ich in der nächsten Sitzung verbessern?", "subtitle": "Konkrete Schritte" }
        ],
        "suggestions-fallback-progress": [
            { "title": "Wie entwickeln sich meine Ergebnisse?", "subtitle": "Über alle Sitzungen" },
            { "title": "Meine starken und schwachen Fähigkeiten", "subtitle": "Aus den Sitzungsbewertungen" },
            { "title": "Worauf sollte ich mich konzentrieren?", "subtitle": "Trainingsschwerpunkt" },
            { "title": "Meine erste und letzte Sitzung vergleichen", "subtitle": "Was sich verbessert hat" }
        ],
        "quota": {
            "remaining": "{count} Nachrichten verbleibend",
            "exhausted": "Ihr KI-Chat-Nachrichtenkontingent ist aufgebraucht.",
            "unavailable": "KI-Chat ist in Ihrem Tarif nicht verfügbar."
        },
        "new-dialog": {
            "title": "Neues Gespräch",
            "subtitle": "Wählen Sie die Quelle, aus der die KI antworten soll",
            "search": "Suchen…",
            "search-empty": "Nichts gefunden",
            "source-type": "Quelle",
            "source-course": "Kurs",
            "source-scenario": "Szenario",
            "source-competency": "Kompetenz",
            "pick-course": "Kurs auswählen",
            "pick-scenario": "Szenario auswählen",
            "pick-competency": "Kompetenz auswählen",
            "pick-target": "Alle Sitzungen oder eine bestimmte Sitzung",
            "all-games": "Alle Sitzungen — mein Fortschritt",
            "all-games-sub": "Bewertungstrends für diese Kompetenz",
            "back": "Zurück",
            "no-games": "Keine abgeschlossenen Sitzungen",
            "empty-competencies": "Noch keine abgeschlossenen Sitzungen",
            "empty-competencies-hint": "Schließen Sie eine Sitzung zu einem Szenario mit Kompetenz ab — die KI-Auswertung erscheint hier",
            "empty-courses": "Noch keine Kurse verfügbar",
            "empty-scenarios": "Noch keine Szenarien verfügbar",
            "tag-game": "Sitzung",
            "start": "Starten",
            "cancel": "Abbrechen"
        },
        "stage": {
            "searching": "Durchsuche deine Materialien…",
            "reading": "Lese Quellen…",
            "writing": "Schreibe die Antwort…",
            "writing_sources": "Analysiere {count} Textpassagen…",
            "summarizing_short": "Frühere Inhalte werden geordnet",
            "searching_short": "Materialien werden durchsucht",
            "reading_short": "Quellen werden gelesen",
            "writing_short": "Antwort wird verfasst",
            "writing_sources_short": "{count} Textpassagen werden analysiert"
        },
        "errors": {
            "send": "Ihre Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
            "quota": "Nachrichtenkontingent erreicht.",
            "rate_limit": "Zu viele Anfragen. Bitte warten Sie eine Minute und versuchen Sie es erneut.",
            "provider_unsupported": "Der Wissensdatenbank-Chat ist mit dem aktuellen KI-Anbieter Ihrer Organisation nicht verfügbar.",
            "generic": "Etwas ist schiefgelaufen."
        }
    },
    "base_title": "The Reflection",
    "base_title_ru": "SkillsTrainer",
    "404_title": "Seite nicht gefunden ⚠️",
    "404_description": "Wir konnten die von Ihnen gesuchte Seite nicht finden.",
    "404_home": "Zurück zur Startseite",
    "401_title": "Sie sind nicht autorisiert! 🔐",
    "401_description": "Sie haben keine Berechtigung, auf diese Seite zuzugreifen. Gehe nach Hause!",
    "401_home": "Zurück zur Startseite",
    "changes_saved": "Änderungen gespeichert",
    "coming_soon": "Kommt bald",
    " ": " ",
    "select_date_and_time": "Datum und Uhrzeit auswählen",
    "select_date": "Datum auswählen",
    "chat": "Chat",
    "menu": "Menü",
    "games": "Sitzungen",
    "tours": "Runden",
    "library": "Bibliothek",
    "library-video": "Video",
    "library-scorm": "Kurse",
    "library-documents": "Dokumente",
    "scenarios": "Szenarien",
    "competencies": "Kompetenzen",
    "competencies-list": "Liste",
    "skills": "Fähigkeiten",
    "home": "Startseite",
    "home_player": "Teilnehmer",
    "player": "Teilnehmer",
    "home_expert": "Experte",
    "reports-analytics-tours": "Runden",
    "reports": "Berichte",
    "ranking": "Rangliste",
    "analytics": "Auswertung",
    "support": "Unterstützung",
    "users": "Benutzer",
    "participants": "Teilnehmer",
    "departments": "Abteilungen",
    "positions": "Positionen",
    "user-custom-fields": "Benutzerdefinierte Felder",
    "administration": "Verwaltung",
    "ai-assistants": "AI-Assistenten",
    "ai-profiles": "AI-Profile",
    "ai-connectors": "AI-Verbindungen",
    "Audit logs": "Audit-Protokolle",
    "organizations": "Organisationen",
    "loading": "Laden...",
    "retry": "Erneut versuchen",
    "previous": "Vorherige",
    "next": "Nächste",
    "save": "Speichern",
    "copy": "Kopieren",
    "copy_failed": "Automatisches Kopieren war nicht möglich. Markieren Sie den Text im Feld und kopieren Sie ihn manuell (Ctrl+C oder ⌘C).",
    "confirm": "Bestätigen",
    "suggest": "Vorschlagen",
    "generate": "Generieren",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "search": "Suchen...",
    "accept": "Akzeptieren",
    "propose": "Vorschlagen",
    "decline": "Ablehnen",
    "send_request": "Anfrage senden",
    "assign": "Zuweisen",
    "actions": " ",
    "evaluators": {
        "ai": "AI",
        "expert": "Experte",
        "player": "Teilnehmer",
        "manager": "Manager",
        "head": "Vorgesetzter"
    },
    "statistics": {
        "date_from": "Von",
        "date_to": "Bis",
        "competence": "Kompetenz",
        "evaluator": "Gutachter",
        "last_games_effectiveness": {
            "effectiveness": "Effizienz",
            "title": "Effizienz nach Sitzungen"
        },
        "skill_trend": {
            "average_score": "Durchschnittliche Punktzahl",
            "game": "Sitzung",
            "score": "Punktzahl",
            "title": "Durchschnittliche Punktzahl nach Kompetenzen"
        },
        "player_competence_radar": {
            "title": "Kompetenz-Statistiken",
            "top": "Top 10",
            "players_in_company": "Teilnehmer im Unternehmen",
            "by_games": "Analyse nach Sitzungen",
            "subtitle": "Gesamtstatistiken für Sie und Ihr Unternehmen",
            "filter": "Filter",
            "you": "Du",
            "company": "Unternehmen",
            "average_score": "durchschnittliche Punktzahl",
            "skills_counted": "basierend auf {counted} von {total} Fähigkeiten"
        }
    },
    "participant": {
        "upcoming_games": "Kommende Sitzungen",
        "for_rank_games": "Zum Bewerten"
    },
    "roles": {
        "player": "Teilnehmer",
        "admin": "Superadmin (System)",
        "scoped_admin": "Leitender Administrator",
        "observer": "Beobachter",
        "captain": "Kapitän",
        "expert": "Experte",
        "lead_expert": "Leitender Experte",
        "manager": "Manager",
        "support": "Unterstützung",
        "early_access": "Frühzeitiger Zugang",
        "head": "Vorgesetzter",
        "candidate": "Kandidat"
    },
    "user-status": {
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "pending": "Ausstehend"
    },
    "pagination": {
        "showing": "anzeige",
        "to": "zu",
        "of": "von",
        "entries": "Einträge"
    },
    "validator": {
        "required": "Dieses Feld ist erforderlich",
        "library": "Die Dateigröße muss unter 500 MB liegen",
        "email": "Das E-Mail-Feld muss eine gültige E-Mail sein",
        "password": "Das Feld muss mindestens einen Großbuchstaben, Kleinbuchstaben, Sonderzeichen und eine Ziffer mit mindestens 8 Zeichen enthalten",
        "confirm": "Die Bestätigung des Passwortbestätigungsfeldes stimmt nicht überein",
        "at_least": "Das Feld muss mindestens enthalten",
        "items": "Artikel",
        "number": "Dieses Feld muss eine ganze Zahl sein",
        "is_odd": "Dieses Feld muss gerade sein",
        "number_between": "Nummer zwischen eingeben",
        "number_and": "und",
        "date_range_required": "Zeitraum erforderlich",
        "invalid_date_range": "Ungültiger Zeitraum",
        "invalid_date_format": "Ungültiges Datumsformat",
        "start_date_after_end_date": "Startdatum muss vor Enddatum liegen",
        "max_180_days": "Maximal 180 Tage"
    },
    "user": {
        "menu": {
            "settings": "Einstellungen",
            "statistics": "Statistik",
            "logout": "Abmelden"
        }
    },
    "theme": {
        "system": "System",
        "light": "Licht",
        "dark": "Dunkel"
    },
    "error": {
        "default": "Entschuldigung, es gab einen Fehler. Unsere Spezialisten wissen bereits Bescheid und werden es so schnell wie möglich beheben.",
        "unauthorized": "Ihre Sitzung ist abgelaufen.",
        "contact-support": "Entschuldigung, es gab einen Fehler. Bitte kontaktieren Sie den technischen Support",
        "forbidden": "Zugriff verweigert"
    },
    "confirmation": {
        "sure": "Sind Sie sicher, dass Sie den Eintrag löschen möchten?",
        "sure_return_to_time_scheduling": "Sind Sie sicher, dass Sie die Sitzung auf die Phase der Startzeitabstimmung zurücksetzen möchten?",
        "sure_mark_failed": "Das Spiel als fehlgeschlagen markieren und alle Bewertungen und Protokolle der Teilnehmer unwiderruflich löschen?",
        "success": "Erfolg!",
        "deleted": "Gelöscht",
        "failed_marked": "Spiel als fehlgeschlagen markiert",
        "cancel": "Abgebrochen",
        "yes": "Ja",
        "no": "Nein"
    },
    "dashboards": {
        "player": {
            "summary": {
                "welcome": "Willkommen zurück",
                "progress": "Ihr Gesamtfortschritt",
                "stats": {
                    "minutes": "Minuten in der Sitzung",
                    "effectiveness": "Effizienz",
                    "completed_games_count": "Erfolgreiche Sitzungen",
                    "total_games_count": "Sitzungen gesamt"
                }
            },
            "cards": {
                "players_rating": {
                    "title": "Unternehmensranking",
                    "player": "Teilnehmer",
                    "effectiveness": "Effizienz"
                }
            }
        },
        "head": {
            "my_stats": "Meine Statistiken",
            "subordinates": "Meine Mitarbeiter",
            "subordinate_stats": "Mitarbeiterstatistiken",
            "select_subordinate": "Mitarbeiter auswaehlen, um Statistiken anzuzeigen",
            "no_subordinates": "Keine Mitarbeiter zugewiesen"
        }
    },
    "chat-page": {
        "last_game": "Letzte Sitzung",
        "chats": "Chats",
        "no-chats": "Keine Chats gefunden",
        "contacts": "Kontakte",
        "choose": "Kontakt wählen",
        "send": "Senden",
        "type": "Geben Sie Ihre Nachricht ein...",
        "no-contacts": "Keine Kontakte gefunden",
        "search": "Suchen...",
        "start_conversation": "Konversation starten",
        "start_connecting": " Beginnen Sie mit der Vernetzung mit den Personen, indem Sie einen der Kontakte links auswählen"
    },
    "scenarios-page": {
        "title": "Titel",
        "export-docx": "Export .docx",
        "copy_title": "Szenario kopieren",
        "generate_ai_title": "KI-Szenario generieren",
        "organization": "Unternehmen",
        "competence": "Kompetenz",
        "actions": " ",
        "add": "Szenario hinzufügen",
        "ai-generate": "KI-Generierung",
        "copy": "Szenario kopieren",
        "add_popup": "Szenario hinzufügen",
        "delete": "Szenario löschen",
        "edit": "Szenario bearbeiten",
        "edit_popup": "Szenario bearbeiten",
        "industries": [
            "FMCG/Einzelhandel",
            "Pharmazeutika",
            "Banken und Fintech",
            "Hotels und Tourismus",
            "IT-Unternehmen/SaaS",
            "Restaurantgeschäft/HoReCa",
            "E-Commerce/Marktplätze",
            "Fertigung/Industrie 4.0",
            "Logistik und T&L",
            "Telekommunikation",
            "Bildung/EdTech",
            "Chemieindustrie",
            "Supply-Chain-Management-Software",
            "Regierung/Gemeinnützige Organisationen"
        ],
        "case_types": [
            "Führung und People-Management",
            "Rekrutierung und Personalbeurteilung",
            "Vertrieb und Kundenservice",
            "Verhandlungen und Einfluss",
            "Konfliktmanagement",
            "Strategie und Umsetzung"
        ],
        "cases": [
            [
                "SMART/OKR-Zielsetzung",
                "Entwicklungsfeedback geben (SBI/COIN)",
                "Delegation",
                "GROW-Coaching",
                "Leistungsbeurteilung",
                "Mentoring"
            ],
            [
                "Kompetenzbasiertes Interview (CBI)",
                "Bewertung/Assessment-Center",
                "Onboarding-Sitzung"
            ],
            [
                "Klassischer Produkt-/Serviceverkauf",
                "Einwände behandeln",
                "Upsell/Cross-sell",
                "Beschwerdebearbeitung",
                "M-Channel-Verkauf"
            ],
            [
                "Interne Unternehmensverhandlungen über Budget/Ressourcen",
                "Kunden-/Lieferantenvertrag",
                "Krisenverhandlungen"
            ],
            [
                "Zwischenmenschlicher Teamkonflikt",
                "Manager-Untergebener",
                "Werte-/Ethikkonflikt"
            ],
            [
                "Projektportfolio-Priorisierung",
                "Change Management",
                "Risikoanalyse"
            ]
        ],
        "formats": [
            "1-1",
            "Gruppen"
        ],
        "labels": {
            "industry": "Branche",
            "case_type": "Fall-Typ",
            "case": "Fall",
            "format": "Format",
            "duration": "Dauer (Minuten)",
            "game_vs_ai": "Sitzung gegen KI",
            "level": "Niveau",
            "competence": "Kompetenz",
            "description": "Szenariobeschreibung",
            "description_hint": "Beschreiben Sie optional das Szenario, das Sie generieren möchten (max. 4000 Zeichen)"
        },
        "generating_in_progress": "Szenario wird generiert, bitte warten..."
    },
    "analytics-page": {
        "tours-page": {
            "tour": "Runde",
            "full_name": "Teilnehmer",
            "games_count": "Sitzungen",
            "team": "Team",
            "export": "Export",
            "effectiveness": "Effizienz"
        }
    },
    "report-filters": {
        "department": "Abteilung",
        "position": "Position",
        "employee": "Mitarbeiter",
        "scenario": "Szenario",
        "competence": "Kompetenz",
        "period": "Zeitraum",
        "reset": "Zurücksetzen",
        "only-period-competence": "Es gelten nur Zeitraum und Kompetenz"
    },
    "competencies-page": {
        "title": "Titel",
        "export-docx": "Export .docx",
        "skills": "Fähigkeiten",
        "text": "Text",
        "display_order": "Sortierung",
        "ai-assistant": "AI-Assistent",
        "language": "Sprache",
        "department": "Abteilung",
        "evaluation-target": "Wen bewerten wir?",
        "evaluation-both": "Beide Teilnehmer",
        "evaluation-team-a": "Nur Team A",
        "evaluation-both-tooltip": "Beide Teilnehmer werden bewertet - geeignet für Verhandlungsszenarien",
        "evaluation-team-a-tooltip": "Nur der Leiter wird bewertet - Feedback-Format",
        "actions": " ",
        "add": "Kompetenz hinzufügen",
        "add_popup": "Kompetenz hinzufügen",
        "delete": "Kompetenz löschen",
        "edit": "Kompetenz bearbeiten",
        "edit_popup": "Kompetenz bearbeiten"
    },
    "faq-page": {
        "title": "Fragen",
        "question": "Frage",
        "text": "Antwort",
        "is_shared": "Verfügbar für alle Unternehmen",
        "actions": " ",
        "visibility": "Sichtbarkeit",
        "visible_to_all": "Sichtbar für alle Benutzer",
        "visible_to_managers": "Nur für Manager sichtbar",
        "add": "Frage hinzufügen",
        "add_popup": "Frage hinzufügen",
        "delete": "Frage löschen",
        "edit": "Frage bearbeiten",
        "edit_popup": "Frage bearbeiten"
    },
    "ai-connectors-page": {
        "title": "AI-Verbindungen",
        "is_shared": "Verfügbar für alle Organisationen",
        "actions": " ",
        "add": "Verbindung hinzufügen",
        "add_popup": "Verbindung hinzufügen",
        "delete": "Verbindung löschen",
        "edit": "Verbindung bearbeiten",
        "edit_popup": "Verbindung bearbeiten",
        "label": "Bezeichnung",
        "provider": "Anbieter",
        "service": "Dienst",
        "organization": "Organisation",
        "status": "Status",
        "region": "Region",
        "endpoint": "Endpunkt",
        "secret": "Passwort/Schlüssel",
        "maxConcurrency": "Maximale Anzahl der Verbindungen",
        "timeoutSec": "Zeitüberschreitung",
        "sortOrder": "Sortierreihenfolge",
        "config": "Konfiguration",
        "modelPrimary": "Primäres Modell",
        "modelLight": "Light-Modell",
        "modelLightHint": "Leer — Light-Aufrufe nutzen das primäre Modell",
        "folderId": "Folder-ID",
        "models": "Modelle",
        "is_default": "Default",
        "notes": "Notizen"
    },
    "skills-page": {
        "title": "Titel",
        "display_order": "Sortierung",
        "competence": "Kompetenz",
        "text": "Indikatoren",
        "actions": " ",
        "add": "Fähigkeit hinzufügen",
        "add_popup": "Fähigkeit hinzufügen",
        "delete": "Fähigkeit löschen",
        "edit": "Fähigkeit bearbeiten",
        "edit_popup": "Fähigkeit bearbeiten"
    },
    "departments-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Abteilung hinzufügen",
        "add_popup": "Abteilung hinzufügen",
        "delete": "Abteilung löschen",
        "edit": "Abteilung bearbeiten",
        "edit_popup": "Abteilung bearbeiten"
    },
    "tours-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Runde hinzufügen",
        "add_popup": "Runde hinzufügen",
        "delete": "Runde löschen",
        "edit": "Runde bearbeiten",
        "edit_popup": "Runde bearbeiten"
    },
    "library-page": {
        "title": "Titel",
        "text": "Beschreibung",
        "video": "Video",
        "courses": "Kurse",
        "video_link_copy": "Link kopieren",
        "video_in_process": "Video wird verarbeitet...",
        "is_public": "Ist öffentlich",
        "actions": " ",
        "add": "Video hinzufügen",
        "add_popup": "Video hinzufügen",
        "delete": "Video löschen",
        "edit": "Video bearbeiten",
        "edit_popup": "Video bearbeiten"
    },
    "library-documents-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Dokument hinzufügen",
        "add_popup": "Dokument hinzufügen",
        "delete": "Dokument löschen",
        "edit": "Dokument bearbeiten",
        "edit_popup": "Dokument bearbeiten",
        "file": "Datei"
    },
    "scorm-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Kurs hinzufügen",
        "loading": "Kurs wird geladen...",
        "add_popup": "Kurs hinzufügen",
        "delete": "Kurs löschen",
        "edit": "Kurs bearbeiten",
        "edit_popup": "Kurs bearbeiten",
        "zip_file": "ZIP-Datei"
    },
    "ai-assistants-page": {
        "external_id": "ID",
        "actions": " ",
        "add": "AI-Assistent hinzufügen",
        "add_popup": "AI-Assistent hinzufügen",
        "delete": "AI-Assistent löschen",
        "edit": "AI-Assistent bearbeiten",
        "edit_popup": "AI-Assistent bearbeiten"
    },
    "ai-prompts-page": {
        "name": "Name",
        "content": "Inhalt",
        "actions": " ",
        "add": "AI-Prompt hinzufügen",
        "add_popup": "AI-Prompt hinzufügen",
        "delete": "AI-Prompt löschen",
        "edit": "AI-Prompt bearbeiten",
        "edit_popup": "AI-Prompt bearbeiten",
        "key": "Slot-Schlüssel",
        "model": "Modell",
        "updated_at": "Aktualisiert",
        "custom": "Benutzerdefiniert",
        "description": "Beschreibung",
        "temperature": "Temperature",
        "top_p": "Top P",
        "reasoning_effort": "Reasoning-Aufwand",
        "reasoning_effort_default": "Standard",
        "required_placeholders": "Erforderliche Platzhalter (müssen im Inhalt enthalten sein)",
        "versions": "Versionsverlauf",
        "no_versions": "Noch keine Versionen",
        "restore": "Wiederherstellen",
        "restore_confirm": "Diese Version wiederherstellen? Ihr Inhalt wird zur aktuellen Version.",
        "restored": "Version wiederhergestellt",
        "current_version": "Aktuell",
        "author": "Autor",
        "error": "Etwas ist schiefgelaufen.",
        "tab_system": "System",
        "tab_custom": "Benutzerdefiniert",
        "system_hint": "Systemprompts werden vom Plattform-Code verwendet. Sie können nicht gelöscht, aber inhaltlich bearbeitet werden.",
        "custom_hint": "Benutzerdefinierte Prompts werden Kompetenzen und AI-Profilen als Override des Bewertungsprompts zugeordnet.",
        "model_from_code": "wird vom Code festgelegt",
        "model_from_code_hint": "Das Modell wird vom Code bestimmt, der den Prompt verwendet; es wird nicht im Prompt selbst gespeichert.",
        "used_by": "Verwendet von",
        "used_by_value": "Kompetenzen: {competencies}, AI-Profile: {profiles}",
        "not_used": "Nicht verwendet",
        "delete_blocked_hint": "Kann nicht gelöscht werden: Der Prompt wird als Override verwendet. {usage}",
        "slot_description": {
            "game_eval_negotiation": "AI-Bewertung von PvP-Sitzungen: Verhandlung",
            "game_eval_feedback": "AI-Bewertung von PvP-Sitzungen: Feedback",
            "game_eval_vs_ai": "AI-Bewertung von Sitzungen gegen KI (wenn das AI-Profil keinen Override hat)",
            "protocol_evaluation": "Ausfüllen des Szenarioprotokolls anhand des Transkripts einer Sitzung gegen KI",
            "voice_agent": "Systemprompt für den virtuellen KI-Gesprächspartner",
            "scenario_generation": "Szenariogenerierung anhand einer Beschreibung",
            "scenario_card_update": "Aktualisierung der Szenariokarte anhand einer KI-Beschreibung",
            "scenario_optimize": "Optimierung der KI-Beschreibung eines Szenarios",
            "skill_report_analysis": "Kompetenzbericht: Analyseschritt",
            "skill_report_recommendations": "Kompetenzbericht: Empfehlungsschritt"
        }
    },
    "ai-profiles-page": {
        "name": "Name",
        "settings": "Einstellungen",
        "temperature": "Fantasie",
        "demeanor": "Verhalten",
        "behavior": "Verhalten, Anweisungen",
        "background": "Biografie",
        "style": "Stil",
        "instructions": "Anweisungen",
        "supportive_phrases": "Unterstützende Sätze",
        "ai_assistant": "KI-Assistent",
        "ai_starts_first": "KI beginnt zuerst",
        "first_phrase": "Erster Satz",
        "closing_phrases": "Abschlusssätze",
        "voice": "Stimme",
        "expert_mode": "Expertenmodus",
        "custom_demeanor_hint": "Aktuelles benutzerdefiniertes Verhalten",
        "is_shared": "Verfügbar für alle Unternehmen",
        "voice_options": {
            "male": "Männlich",
            "female": "Weiblich"
        },
        "demeanor_options": {
            "friendly": {
                "title": "Freundlich",
                "description": "Leicht zugänglich und angenehm"
            },
            "critical": {
                "title": "Kritisch",
                "description": "Weist häufig auf Fehler und Verbesserungsbereiche hin"
            },
            "empathetic": {
                "title": "Empathisch",
                "description": "Sehr sensibel für die Gefühle und Emotionen anderer"
            },
            "enthusiastic": {
                "title": "Enthusiastisch",
                "description": "Zeigt intensive Begeisterung und Eifer"
            },
            "analytical": {
                "title": "Analytisch",
                "description": "Konzentriert sich auf Logik und detaillierte Problemlösung"
            },
            "curious": {
                "title": "Neugierig",
                "description": "Begierig zu lernen und Fragen zu stellen"
            },
            "assertive": {
                "title": "Durchsetzungsfähig",
                "description": "Selbstbewusst und selbstsicher"
            },
            "blunt": {
                "title": "Direkt",
                "description": "Direkt und auf den Punkt gebracht"
            },
            "skeptical": {
                "title": "Skeptisch",
                "description": "Misstrauisch gegenüber neuen Lösungen und Ideen"
            },
            "neutral": {
                "title": "Neutral",
                "description": "Ausgewogen und objektiv im Kommunikationsstil"
            },
            "casual": {
                "title": "Locker",
                "description": "Entspannt und gesprächig im Ton"
            }
        },
        "placeholders": {
            "name": "Zum Beispiel: Sergey (höflich und freundlich)",
            "demeanor": "Zum Beispiel: Freundlich, höflich und gesellig...",
            "background": "Zum Beispiel: Wurde zweimal entlassen...",
            "behavior": "Zum Beispiel: Unterbricht nicht, hört aktiv zu...",
            "first_phrase": "Zum Beispiel: Guten Tag! Wie ist Ihre Stimmung?",
            "closing_phrases": "Zum Beispiel: Wir haben fast keine Zeit mehr, daher schlage ich vor, unser Treffen schnell zusammenzufassen."
        },
        "actions": " ",
        "add": "AI-Profil hinzufügen",
        "add_popup": "AI-Profil hinzufügen",
        "subtitle": "Wie der Gesprächspartner in der Sitzung aussieht und klingt",
        "preview": {
            "title": "Vorschau",
            "unnamed": "Ohne Namen",
            "voice": "Stimme {name}",
            "defaultVoice": "Standardstimme",
            "defaultPhoto": "Standardfoto",
            "listen": "Stimme anhören",
            "defaultVoiceNotice": "Die Stimme wird zu Beginn der Sitzung gewählt – vorher anhören ist nicht möglich",
            "photoPlaceholder": "Hier erscheint das Foto"
        },
        "delete": "AI-Profil löschen",
        "edit": "AI-Profil bearbeiten",
        "edit_popup": "AI-Profil bearbeiten",
        "avatar_hint": "Avatarbild",
        "avatar_save_first": "Speichern Sie zuerst das Profil, um Avatar-Uploads zu aktivieren",
        "avatar_requirements": "Max. 1 MB • Empfohlen: 1536×1024 • Seitenverhältnis: 3:2",
        "max_characters": "Max. {max} Zeichen"
    },
    "games-page": {
        "game-with-ai": "Sitzung mit KI",
        "organization": "Organisation",
        "status": "Status",
        "failure_reasons": {
            "protocol_not_agreed": "Die Protokollgenehmigung wurde von den Teilnehmern nicht abgeschlossen",
            "protocol_approval_expired": "Zeit für die Protokollgenehmigung ist abgelaufen",
            "annulled": "Die Sitzung wurde annulliert",
            "expired": "Die Sitzungszeit ist abgelaufen",
            "assignment_changed": "Die Kurszuweisung im Lernsystem wurde geändert"
        },
        "play": "Spielen",
        "meetings_unavailable": "Videositzungen zwischen Teilnehmern sind vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.",
        "import": "Importieren",
        "scenario": "Speilnamen",
        "tour": "Runde",
        "game_types": {
            "classic": "Klassischer Modus",
            "vs_ai": "Sitzung gegen KI",
            "uploaded_recording": "Aufnahme"
        },
        "upload_recording": {
            "file": "Aufnahmedatei",
            "file_hint": "Video oder Audio, bis 1 GB",
            "uploaded": "Datei hochgeladen",
            "file_too_large": "Die Datei ist größer als 1 GB",
            "upload_error": "Die Datei konnte nicht hochgeladen werden",
            "player": "Teilnehmer",
            "rate_both": "Beide Teilnehmer bewerten",
            "second_player": "Zweiter Teilnehmer",
            "open_session": "Sitzung öffnen"
        },
        "game_targets": {
            "user": "Teilnehmer",
            "position": "Position",
            "department": "Abteilung"
        },
        "number": "Nummer",
        "start_up_to": "Sitzung möglich bis zum",
        "start_time": "Startzeit",
        "teamA": "Team A",
        "teamB": "Team B",
        "others": "Teilnehmer",
        "actions": " ",
        "edit_results": "Ergebnisse ändern",
        "add": "Sitzung hinzufügen",
        "add_popup": "Sitzung hinzufügen",
        "delete": "Sitzung löschen",
        "edit": "Sitzung bearbeiten",
        "edit_popup": "Sitzung bearbeiten",
        "time_scheduling": "Startzeitplanung",
        "return_to_time_scheduling": "Zurück zur Abstimmung der Startzeit",
        "preparation": "Vorbereitung für die Sitzung",
        "view_scenario": "Szenario ansehen",
        "protocol": "Protokollgenehmigung",
        "not_agreed": "Nicht zugestimmt",
        "expert-accept": "Annehmen und zur Bewertung übergehen",
        "expert-decline": "Ablehnen",
        "hide_ai_results": "KI-Bewertung ausblenden",
        "show_ai_results": "KI-Bewertung anzeigen",
        "mark_failed": "Als fehlgeschlagen markieren",
        "popup": {
            "start_up_to": "Sitzung möglich bis zum",
            "target": "Wem soll die Sitzung zugewiesen werden?",
            "custom_field_value": "Wert von „{field}“",
            "target_preview_count": "Zu erstellende Sitzungen: {count}",
            "target_preview_empty": "Kein Mitarbeiter passt zu dieser Auswahl — es wird keine Sitzung erstellt",
            "target_preview_limit_exceeded": "Das ist mehr, als eine Zuweisung erstellen kann (höchstens {limit}). Verkleinern Sie die Auswahl, die Anzahl der Fälle oder die Anzahl der Kopien",
            "copies_per_player": "Kopien jedes Falls pro Spieler",
            "position": "Position",
            "department": "Abteilung",
            "scenario": "Speilnamen",
            "optional": "Optional, kann weggelassen werden",
            "protocol_time": "Protokollzeit",
            "protocol_time_hint": "Nummer zwischen 1 und 1440",
            "preparation_time": "Vorbereitungszeit",
            "preparation_time_hint": "In Minuten",
            "game_duration": "Sitzungsdauer",
            "game_duration_hint": "Nummer zwischen 1 und 60",
            "is_team": "Speilnamen für Teams",
            "is_camera_required": "Teilnehmerkameras sind erforderlich",
            "is_self_rated": "Teilnehmer können sich selbst bewerten",
            "is_each_other_rated": "Teilnehmer können sich gegenseitig bewerten",
            "is_expert_rated": "Expertenbewertung ist verfügbar",
            "is_ai_rated": "KI-Bewertung ist verfügbar",
            "show_results": "Ergebnisse anzeigen",
            "automatically": "automatisch",
            "manually": "manuell",
            "is_public_hint": "Jeder Beobachter kann sich verbinden",
            "is_public": "Öffentliche Sitzung",
            "team_a": "Team A",
            "team_b": "Team B",
            "player_a": "Teilnehmer A",
            "player_b": "Teilnehmer B",
            "expert": "Experte",
            "observers": "Beobachter",
            "tour": "Runde",
            "search": "Suchen...",
            "choose_players": "Teilnehmer auswählen",
            "choose_expert": "Experte auswählen",
            "choose_observers": "Beobachter auswählen",
            "choose_scenario": "Speilnamen auswählen",
            "choose_tour": "Runde auswählen",
            "expert_empty": "Wird kein Experte ausgewählt, kann der Kapitän wählen",
            "captain": "Kapitän",
            "": "",
            "protocol": {
                "title": "Protokollgenehmigung",
                "target": "Ziel",
                "await_approval": "Zustimmung des Gegners abwarten",
                "await_proposal": "Vorschlag des Gegners abwarten",
                "questions": "Fragen für Ihr Team",
                "questions_a": "Fragen für Team A",
                "questions_b": "Fragen für Team B",
                "not_agreed": "Keine Einigung",
                "not_agreed_confirm": "Die Sitzung wird erfolglos beendet und die Ergebnisse werden nicht gewertet. Diese Aktion ist unwiderruflich.",
                "not_agreed_done": "Die Sitzung wurde erfolglos beendet."
            },
            "start_time": {
                "title": "Startzeit",
                "must_start_by": "Muss starten bis"
            },
            "edit_results": {
                "title": "Ergebnisse ändern"
            },
            "preparation": {
                "title": "Vorbereitung für die Sitzung",
                "description": "Beschreibung",
                "description_team": "Teambeschreibung",
                "notes": "Persönliche Notizen"
            },
            "import": {
                "download_example": "Beispiel herunterladen",
                "title": "Sitzungsimport",
                "button": "Import starten",
                "label": "Excel-Datei"
            },
            "create_multi_scenario_games_immediately": "Alle Sitzungen werden sofort erstellt",
            "create_multi_scenario_games_sequentially": "Sitzungen werden nacheinander erstellt (nach erfolgreichem Abschluss jeder Sitzung)"
        }
    },
    "ai-game": {
        "title": "Sitzung gegen KI",
        "recording": "Aufnahme",
        "ai": "KI",
        "you": "Du",
        "ai_ready": "Bereit",
        "camera_off": "Kamera ist aus",
        "stop_game": "Sitzung beenden",
        "start_game": "Sitzung starten",
        "mic_permission": "Bitte erteilen Sie in den Einstellungen Mikrofonberechtigungen, um die Sitzung zu starten",
        "permissions_granted": "Berechtigungen erfolgreich erteilt!",
        "close": "Schließen",
        "microphone_required": "Please grant microphone permissions to start the session",
        "mic_required": "Schalten Sie das Mikrofon ein, um die Sitzung zu starten",
        "mic_not_detected": "Noch kein Ton erkannt — versuchen Sie zu sprechen oder prüfen Sie Ihr Mikrofon",
        "permissions_needed": "Mikrofonzugriff ist erforderlich. Kamera ist optional",
        "agent": {
            "initializing": "Initializing...",
            "listening": "Listening",
            "thinking": "Thinking...",
            "speaking": "Speaking",
            "waiting": "Waiting for agent..."
        },
        "waiting_for_start": "Start the session to begin conversation",
        "grant_microphone": "Grant Microphone Access",
        "game_not_found": "Session Not Found",
        "game_not_found_desc": "Session with ID {id} could not be located.",
        "confirm": {
            "start_question": "Sind Sie sicher? Die Sitzung kann nicht pausiert werden",
            "start_title": "Sitzung gestartet",
            "start_success": "Die Sitzung wurde erfolgreich gestartet",
            "start_cancel_title": "Sitzung nicht gestartet",
            "start_cancel_msg": "Der Sitzungsstart wurde abgebrochen",
            "end_question": "Sind Sie sicher? Die Sitzung wird beendet",
            "end_title": "Sitzung beendet",
            "end_success": "Die Sitzung wurde erfolgreich beendet",
            "end_cancel_title": "Sitzung nicht beendet",
            "end_cancel_msg": "Das Sitzungsende wurde abgebrochen"
        },
        "voice": {
            "disconnected": "Getrennt",
            "connecting": "Verbindung wird hergestellt...",
            "connected": "Mit Server verbunden",
            "connection_error": "Verbindung zum Sprachagenten fehlgeschlagen",
            "game_already_finished": "Dieses Spiel ist bereits beendet",
            "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
            "no_rooms_available": "Derzeit sind keine Räume verfügbar. Bitte versuchen Sie es später erneut.",
            "preparing_recording": "Aufnahme wird vorbereitet, neuer Versuch in {seconds}s…",
            "recording_service_overloaded": "Aufnahmedienst überlastet. Bitte versuchen Sie es in einigen Minuten erneut.",
            "session_quota_exhausted": "Das Sitzungspaket Ihrer Organisation ist aufgebraucht. Bitte wenden Sie sich an Ihren Manager.",
            "connection_blocked": "Ihr Netzwerk hat den Aufbau der KI-Verbindung blockiert. Erlauben Sie HTTPS (443) zu den erforderlichen Domains und versuchen Sie es erneut.",
            "connection_blocked_signaling": "Die Firewall oder der Proxy Ihres Netzwerks blockiert die Verbindung zum Sprachserver. Versuchen Sie, sich über ein anderes Netzwerk oder einen mobilen Hotspot zu verbinden.",
            "reconnecting": "Reconnecting...",
            "disconnect_dialog_title": "Connection Lost",
            "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
            "disconnect_retry": "Reconnect",
            "disconnect_finish": "Finish Session",
            "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
            "stop_failed": "Failed to stop the session",
            "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
            "mic_toggle_failed": "Failed to toggle microphone",
            "camera_toggle_failed": "Failed to toggle camera",
            "duplicate_tab_title": "Session Open in Another Tab",
            "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
            "duplicate_tab_back": "Go Back",
            "duplicate_tab_disconnect_title": "Opened in Another Tab",
            "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
        },
        "permissions_denied_safari": "Kamera- oder Mikrofonzugriff wurde verweigert. Gehen Sie zu Safari-Einstellungen > Websites > Kamera/Mikrofon und erlauben Sie den Zugriff für diese Seite.",
        "supported": "Browser unterstützt"
    },
    "positions-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Position hinzufügen",
        "add_popup": "Position hinzufügen",
        "delete": "Position löschen",
        "edit": "Position bearbeiten",
        "edit_popup": "Position bearbeiten"
    },
    "user-custom-fields-page": {
        "title": "Titel",
        "type": "Typ",
        "options_count": "Werte",
        "actions": " ",
        "add": "Feld hinzufügen",
        "add_popup": "Feld hinzufügen",
        "delete": "Feld löschen",
        "delete_confirm": "Feld löschen? Die bei den Benutzern gespeicherten Werte werden nicht mehr angezeigt.",
        "edit": "Feld bearbeiten",
        "edit_popup": "Feld bearbeiten",
        "empty": "Noch keine benutzerdefinierten Felder",
        "error": "Feld konnte nicht gespeichert werden",
        "type_text": "Text",
        "type_select": "Auswahlliste",
        "type_locked_hint": "Der Typ kann nach dem Erstellen des Feldes nicht mehr geändert werden",
        "options": "Werte",
        "options_hint": "Die Reihenfolge der Werte hier entspricht der Reihenfolge in der Auswahlliste",
        "options_required": "Fügen Sie mindestens einen Wert hinzu",
        "option_title": "Wert",
        "option_add": "Wert hinzufügen",
        "option_delete": "Wert löschen",
        "option_delete_confirm": "Wert löschen? Bei Benutzern, für die er ausgewählt war, wird er entfernt.",
        "option_move_up": "Nach oben verschieben",
        "option_move_down": "Nach unten verschieben"
    },
    "organizations-page": {
        "name": "Name",
        "host": "Host",
        "duel_limit": "Duell-Limit",
        "max_users": "Max. Benutzer",
        "max_users_hint": "0 = unbegrenzt",
        "max_vs_ai_games_per_scenario": "Max. KI-Spiele pro Spieler und Szenario",
        "max_vs_ai_games_per_scenario_hint": "Leer = kein Limit. Gilt, wenn Spieler Spiele selbst erstellen",
        "employee_report_daily_limit": "Berichtslimit für Mitarbeiter pro Tag",
        "employee_report_daily_limit_hint": "Leer = plattformweites Limit. Gilt für Manager und Vorgesetzte",
        "employee_report_hourly_limit": "Berichtslimit für Mitarbeiter pro Stunde",
        "employee_report_hourly_limit_hint": "Leer = plattformweites Limit. Gilt für Manager und Vorgesetzte",
        "registration": "Registrierung offen",
        "timezone": "Zeitzone",
        "locale": "Ort",
        "users_count": "Benutzer",
        "actions": " ",
        "add": "Organisation hinzufügen",
        "add_popup": "Organisation hinzufügen",
        "delete": "Organisation löschen",
        "edit": "Organisation bearbeiten",
        "edit_popup": "Organisation bearbeiten",
        "available_languages": "Verfügbare Sprachen",
        "show_game_numbers_for_player": "Sitzungsnummern für Teilnehmer anzeigen",
        "allow_players_choose_expert": "Teilnehmern erlauben, Experten auszuwählen",
        "send_message": "Nachricht an Manager senden",
        "message": "Nachricht",
        "send": "Senden",
        "clear_message": "Nachricht löschen",
        "current_message": "Aktuelle Nachricht",
        "two_factor_method": "Zwei-Faktor-Authentifizierung",
        "two_factor_disabled": "Deaktiviert",
        "two_factor_email": "E-Mail",
        "two_factor_sms": "SMS",
        "hidden_menu_items": "Hidden menu items",
        "hide_ai_results": "KI-Ergebnisse ausblenden",
        "hide_player_rating": "Unternehmensranking für Teilnehmer ausblenden",
        "show_character_memory_to_player": "Charaktergedächtnis für den Spieler anzeigen",
        "show_meeting_recap_to_player": "Zusammenfassung des Treffens für den Spieler anzeigen",
        "create_user_on_external_launch": "Benutzer beim ersten Zugriff eines externen Systems erstellen",
        "create_user_on_external_launch_hint": "Ist die Option deaktiviert, wird ein Lernender, der zum ersten Mal über das externe System kommt, abgewiesen, statt ein Spiel zu bekommen. Jeder auf diese Weise angelegte Benutzer belegt einen Platz im Abonnement.",
        "allow_external_email_linking": "Verknüpfung externer Benutzer per E-Mail erlauben",
        "allow_external_email_linking_hint": "Ist die Option aktiviert, wird eine externe Person einem bereits vorhandenen Mitarbeiter zugeordnet, wenn das externe System deren E-Mail-Adresse von seinem eigenen Server übermittelt hat. Ist sie deaktiviert, wird ein solcher Start abgelehnt, und es wird kein zweiter Benutzer mit dieser Adresse angelegt."
    },
    "users-page": {
        "import": "Importieren",
        "user": "Benutzer",
        "roles": "Rollen",
        "effectiveness": "Effizienz",
        "department": "Abteilung",
        "position": "Position",
        "status": "Status",
        "actions": " ",
        "add": "Benutzer hinzufügen",
        "add_popup": "Neuer Benutzer",
        "last_login_at": "Letzte Anmeldung",
        "delete": "Löschen",
        "view": "Anzeigen",
        "login": "Anmelden",
        "message": "Nachricht",
        "activate": "Aktivieren",
        "deactivate": "Blockieren",
        "edit_popup": "Benutzer bearbeiten",
        "total_in_org": "Gesamt in der Organisation",
        "multi_role_note": "Ein Benutzer mit mehreren Rollen wird in jedem Badge mitgezählt",
        "filter_role": "Rolle",
        "all_roles": "Alle Rollen",
        "filter_activity": "Abgeschlossene Szenarien",
        "activity_played": "Ja",
        "activity_not_played": "Nein",
        "filter_activity_from": "Gespielt seit",
        "filter_last_login_from": "Anmeldedatum",
        "filter_custom_field": "Benutzerdefiniertes Feld",
        "filter_custom_field_value": "Wert von „{field}“",
        "last_login_never": "Nie angemeldet",
        "last_login_since": "Angemeldet seit",
        "cases_progress": "Abgeschlossene Fälle",
        "cases_progress_value": "{completed} von {assigned}",
        "export": "Export",
        "popup": {
            "name": "Vorname",
            "last_name": "Nachname",
            "patronymic": "Vatersname",
            "phone": "Telefon",
            "timezone": "Zeitzone",
            "language": "Sprache",
            "country": "Land",
            "invalid_phone": "Falsche Telefonnummer",
            "department": "Abteilung",
            "position": "Position",
            "effectiveness": "Effizienz",
            "roles": "Rollen",
            "organizations": "Unternehmen",
            "blocked": "Gesperrt",
            "is_active": "Ist aktiv",
            "email_verified": "E-Mail ist verifiziert",
            "email_not_verified": "E-Mail ist nicht verifiziert",
            "subordinates": "Untergebene",
            "search_subordinates": "Teilnehmer suchen...",
            "import": {
                "download_example": "Beispiel herunterladen",
                "title": "Benutzerimport",
                "button": "Import starten",
                "label": "Excel-Datei",
                "marker_hint": "Bei einem bereits vorhandenen Benutzer behält eine leere Zelle den aktuellen Wert, ein Bindestrich (-) leert das Feld.",
                "result_title": "Import gestartet",
                "result_created": "Wird erstellt: {count}",
                "result_updated": "Wird aktualisiert: {count}",
                "result_skipped": "Übersprungen: {count}",
                "result_skipped_row": "Zeile {row}, {email}: {reason}",
                "result_truncated": "…und {count} weitere übersprungene Zeilen"
            }
        }
    },
    "users-ranking-page": {
        "user": "Benutzer",
        "roles": "Rollen",
        "effectiveness": "Effektivität",
        "average-effectiveness": "Ø pro Sitzung",
        "sessions-count": "Sitzungen",
        "department": "Abteilung",
        "position": "Position",
        "status": "Status",
        "export": "Exportieren",
        "actions": " "
    },
    "user-detail": {
        "games_finished": "Sitzungen beendet",
        "not_found": "Benutzer mit wurde nicht gefunden",
        "games_total": "Gesamt",
        "username": "Benutzername",
        "phone": "Telefon",
        "status": "Status",
        "language": "Sprache",
        "timezone": "Zeitzone",
        "edit": "Bearbeiten",
        "department": "Abteilung",
        "position": "Position",
        "activate": "Aktivieren",
        "block": "Blockieren",
        "account": {
            "title": "Konto",
            "summary": {
                "title": "Übersicht",
                "games": "Gespielte Sitzungen",
                "place": "Platz",
                "effectiveness": "Effizienz",
                "time": "Zeit"
            }
        },
        "security": {
            "title": "Sicherheit",
            "change_password_title": "Passwort ändern",
            "change_password": "Passwort ändern",
            "new_password": "Neues Passwort",
            "confirm_new_password": "Neues Passwort bestätigen",
            "password_requirements": "Passwortanforderungen:",
            "password_requirements_1": "Mindestens 8 Zeichen lang - je mehr, desto besser",
            "password_requirements_2": "Mindestens ein Kleinbuchstabe",
            "password_requirements_3": "Mindestens eine Zahl, ein Symbol oder ein Leerzeichen"
        },
        "statistics": {
            "title": "Statistiken"
        }
    },
    "game": {
        "character_memory": {
            "title": "Woran sich der Charakter erinnert",
            "subtitle": "Die Erinnerung an frühere Treffen, die der Charakter in dieses Spiel mitbringt",
            "preview_subtitle": "Die Erinnerung ist noch nicht festgelegt – der Charakter erhält sie in dem Moment, in dem das Spiel startet",
            "unavailable": "Das vorherige Treffen ist für den Charakter nicht verfügbar: Er beginnt das Gespräch, ohne sich daran zu erinnern.",
            "agreements": "Vereinbarungen",
            "player_commitments": "Zusagen des Spielers",
            "character_commitments": "Zusagen des Charakters",
            "open_issues": "Offene Fragen",
            "facts": "Genannte Fakten",
            "attitude": "Einstellung gegenüber dem Spieler",
            "evaluation_passed": "Dem Charakter wurden die Bewertungsergebnisse jenes Treffens übermittelt",
            "evaluation_not_ready": "Die Bewertung jenes Treffens liegt noch nicht vor – der Charakter erhält sie, sobald sie berechnet wurde.",
            "evaluation_hidden": "Die Bewertungstexte sind durch die Organisationseinstellungen ausgeblendet.",
            "overall_effectiveness": "Gesamteffektivität",
            "outcome": {
                "deal": "Einigung",
                "partial": "Teileinigung",
                "no_deal": "Keine Einigung",
                "unclear": "Unklar"
            }
        },
        "meeting_recap": {
            "title": "Zusammenfassung des Treffens",
            "outcome": "Ergebnis des Treffens",
            "agreements": "Vereinbarungen",
            "player_commitments": "Zusagen des Spielers",
            "character_commitments": "Zusagen des Charakters",
            "open_issues": "Offene Fragen",
            "facts": "Genannte Fakten",
            "pending": "Die Zusammenfassung des Treffens wird noch erstellt. Schauen Sie etwas später wieder vorbei.",
            "unavailable": "Die Zusammenfassung dieses Treffens konnte nicht erstellt werden.",
            "none": "Für dieses Spiel gibt es keine Zusammenfassung."
        },
        "title": "Sitzung",
        "team": "Team",
        "expert": "Experte",
        "points": "Punkte",
        "your_result": "Ihr Ergebnis",
        "joined_at": "Beigetreten:",
        "ended_at": "Abschlussdatum",
        "min": "Min.",
        "duration": "Dauer",
        "from_average": "vom Durchschnitt",
        "ai_expert": "KI-Experte",
        "ai_evaluation_in_progress": "KI-Bewertung läuft",
        "delete_ai_request": "KI-Feedback löschen",
        "ai_expert_refresh": "KI-Ergebnisse aktualisieren",
        "ai_expert_refresh_rejected": {
            "evaluation_not_completed": "Die KI-Ergebnisse können gerade nicht aktualisiert werden: Die KI-Bewertung läuft noch.",
            "answer_pending": "Die KI-Ergebnisse können gerade nicht aktualisiert werden: Die Antwort der KI steht noch aus.",
            "recognition_pending": "Die KI-Ergebnisse können gerade nicht aktualisiert werden: Die Aufnahme wird noch transkribiert.",
            "recognition_has_no_speech": "In der Aufnahme wurde keine Sprache erkannt, daher können die KI-Ergebnisse nicht aktualisiert werden.",
            "recognition_has_too_little_speech": "In der Aufnahme findet kaum ein Gespräch zwischen den Teilnehmern statt, daher wurde keine KI-Bewertung durchgeführt.",
            "no_ai_evaluation": "Diese Sitzung hat keine KI-Bewertung mehr.",
          "game_evaluation_blocked": "Die Sitzung hat nicht stattgefunden oder wurde annulliert, daher ist keine KI-Bewertung verfügbar."
        },
        "ai_expert_unavailable": {
            "recognition_has_no_speech": "In der Aufnahme wurde keine Sprache erkannt, daher wurde keine KI-Bewertung durchgeführt.",
            "recognition_has_too_little_speech": "In der Aufnahme findet kaum ein Gespräch zwischen den Teilnehmern statt, daher wurde keine KI-Bewertung durchgeführt.",
          "game_evaluation_blocked": "Die Sitzung hat nicht stattgefunden oder wurde annulliert, daher ist keine KI-Bewertung verfügbar."
        },
        "ai_expert_refresh_failed": "Die KI-Ergebnisse konnten nicht aktualisiert werden.",
        "speaker_mapping": {
            "title": "Teilnehmer und Stimmen",
            "voice": "Stimme {number}",
            "unknown": "Nicht identifiziert",
            "needs_review": "Teilnehmer überprüfen",
            "needs_review_hint": "Die Teilnehmer wurden möglicherweise falsch identifiziert: Stellen Sie sicher, dass das KI-Feedback die richtigen Personen erreicht hat.",
            "failed": "Die Teilnehmer konnten nicht automatisch identifiziert werden.",
            "unavailable": "Der KI-Anbieter war nicht erreichbar; die Teilnehmer werden bei der nächsten Bewertung identifiziert.",
            "empty": "Das Transkript enthält keine Sprachaufnahmen, anhand derer sich Teilnehmer identifizieren lassen.",
            "corrected_manually": "Manuell korrigiert",
            "under_reevaluation": "Die KI-Bewertung läuft mit diesen Teilnehmern. Bis sie abgeschlossen ist, zeigt die Seite die vorherigen Ergebnisse.",
            "confirm": "Teilnehmer sind korrekt",
            "review": "Prüfen",
            "dialog_hint": "Weisen Sie jeder Stimme einen Teilnehmer zu. Nach dem Speichern wird das KI-Feedback erneut angefordert.",
            "save": "Speichern",
            "cancel": "Abbrechen",
            "confirmed": "Teilnehmer bestätigt",
            "fixed": "Teilnehmer korrigiert, KI-Feedback erneut angefordert",
            "action_failed": "Aktion konnte nicht abgeschlossen werden"
        },
        "ai_expert_created": "Der Sitzungsbewertungsprozess wurde gestartet. Dies wird ein paar Minuten dauern. Sie können die Seite verlassen, da wir Ihnen eine Benachrichtigung senden, wenn die Bewertung verfügbar ist.",
        "expert_already_requested": "Bewertung wurde bereits von einem anderen Teilnehmer angefordert",
        "request_expert": "Experten anfordern",
        "assign_expert": "Experten zuweisen",
        "ai_process": "Bitte warten, wird verarbeitet",
        "analyzing_results": "Sitzungsergebnisse werden analysiert...",
        "complete_expert_request": "Bewertung abschließen",
        "tabs": {
            "description": {
                "title": "Szenariobeschreibung",
                "subtitle": "Sitzungsinformationen und Regeln",
                "situation": "Situation",
                "your_role": "Ihre Rolle",
                "player_role": "Rolle des Spielers: {name}",
                "team_tab": "Team {team}",
                "empty": "In dieser Sitzung gibt es keine Beschreibungen.",
                "load_error": "Die Beschreibung konnte nicht geladen werden. Bitte versuchen Sie es später erneut."
            },
            "results": {
                "title": "Ergebnisse",
                "effectiveness_summary": "Teameffektivität",
                "your_effectiveness": "Ihre Effektivität",
                "parameters_section": "Parameter",
                "parameter": "Parameter",
                "target": "Ziel",
                "coefficient": "Koeffizient",
                "value": "Stimmung",
                "points": "Punkte",
                "points_short": "Punkte",
                "combinations": "Kombinationen",
                "combination_bonus": "Kombinationsbonus",
                "questions": "Fragen",
                "question": "Frage",
                "answer": "Antwort",
                "total": "Gesamt"
            },
            "comments": {
                "title": "Videoanalyse",
                "comments": "Kommentare",
                "no_comments": "Noch keine Kommentare",
                "no_video": "Video nicht verfügbar",
                "video_processing": "Video wird verarbeitet...",
                "count": "Kommentare",
                "delete": "Löschen",
                "edit": "Bearbeiten",
                "popup": {
                    "add": "Kommentar hinzufügen",
                    "edit": "Kommentar bearbeiten",
                    "comment": "Kommentar",
                    "player": "Teilnehmer",
                    "all": "An alle"
                }
            },
            "feedback": {
                "title": "Sitzungsbewertung",
                "no_feedback": "Noch keine Bewertungen",
                "no_feedback_description": "Feedback für diese Sitzung wurde noch nicht hinzugefügt",
                "overall_score": "Gesamtbewertung",
                "skills_evaluated": "{count} Fähigkeiten bewertet",
                "no_comment": "Kein Kommentar angegeben",
                "score_button": "Teilnehmer bewerten",
                "player": "Teilnehmer",
                "author": "Autor",
                "download": "Video herunterladen",
                "download_transcript": "Transkript herunterladen",
                "evaluators": {
                    "ai": "AI",
                    "expert": "Experte",
                    "player": "Teilnehmer",
                    "manager": "Manager",
                    "head": "Vorgesetzter"
                },
                "popup": {
                    "score": {
                        "title": "Teilnehmerbewertung",
                        "comment": "Kommentar",
                        "error": "Sie müssen alle Teilnehmerkapazitäten bewerten",
                        "save_error": "Die Bewertung konnte nicht gespeichert werden. Möglicherweise haben Sie keine Berechtigung, diesen Teilnehmer zu bewerten."
                    }
                }
            },
            "checklist": {
                "title": "Checkliste",
                "total": "Bestandene Punkte",
                "pass": "Bestanden",
                "fail": "Nicht bestanden",
                "cannot_assess": "Nicht bewertbar",
                "comment": "Allgemeiner Kommentar",
                "category": "Kategorie",
                "author": "Bewerter",
                "player": "Teilnehmer",
                "passed_of": "{passed} von {total}",
                "evidence": "Beleg",
                "rationale": "Begründung",
                "no_results": "Noch keine Checklisten-Bewertung",
                "no_results_description": "Diese Sitzung wurde noch nicht anhand einer Checkliste bewertet"
            }
        }
    },
    "scenario": {
        "steps": {
            "information": {
                "create_new_ai_profile": "Neu erstellen",
                "edit_ai_profile": "Bearbeiten",
                "delete_ai_profile": "Löschen",
                "confirm_delete_ai_profile": "Sind Sie sicher, dass Sie dieses KI-Profil löschen möchten?",
                "first_header": "Grundeinstellungen",
                "second_header": "KI-Teilnehmer",
                "third_header": "Szenariobeschreibung",
                "is_public": "Öffentlich",
                "is_public_hint": "Wenn aktiviert — wird das Szenario für die Auswahl durch Teilnehmer verfügbar sein.",
                "title": "Information",
                "subtitle": "Grunddaten des Speilnamen",
                "image": "Szenariobild",
                "field_title": "Titel",
                "competence": "Kompetenz",
                "description": "Beschreibung",
                "description_a": "Beschreibung für Team A",
                "description_b": "Beschreibung für Team B",
                "next_scenario_label": "Nächstes Szenario",
                "next_scenario_placeholder": "Nicht ausgewählt",
                "next_scenario_hint": "Nach Abschluss der Sitzung mit diesem Szenario wird automatisch eine Sitzung mit dem nächsten Szenario erstellt.",
                "memory_header": "Verknüpfung mit dem nächsten Treffen",
                "memory_group_evaluation": "Die Bewertung des nächsten Treffens",
                "memory_group_character": "Der Charakter des nächsten Treffens",
                "memory_pass_to_next": "erinnert sich an dieses Treffen",
                "memory_pass_to_next_hint": "Der Charakter des nächsten Szenarios beginnt das Gespräch so, als kenne er sein Gegenüber bereits: Er erhält eine kurze Zusammenfassung dieses Treffens, die Vereinbarungen, die Zusagen beider Seiten, die offenen Fragen und die genannten Fakten. Die Gesprächsaufzeichnung und wörtliche Zitate werden ihm nicht übermittelt. Aktivieren Sie diese Option, wenn das nächste Treffen dieses fortsetzt: eine zweite Verhandlungsrunde, ein wiederkehrendes Vier-Augen-Gespräch.",
                "memory_pass_evaluation_to_next": "kennt die Bewertung dieses Treffens",
                "memory_pass_evaluation_to_next_hint": "Zusammen mit dem Gedächtnis erhält der Charakter die Feedbacktexte zu den Fähigkeiten und das Gesamtergebnis dieses Treffens und kann sich wie ein Coach verhalten, der sich merkt, was dem Spieler gut gelungen ist.",
                "memory_evaluate_next_with_agreements": "berücksichtigt die Vereinbarungen dieses Treffens",
                "memory_evaluate_next_with_agreements_hint": "Bei der Bewertung des nächsten Treffens sieht der KI-Experte die Vereinbarungen, die Zusagen beider Seiten und die offenen Fragen aus diesem Treffen und kann prüfen, ob der Spieler sein Wort gehalten hat. Punktzahlen und Bewertungstexte des vorherigen Treffens werden dem Experten nicht übermittelt, damit sie die neue Bewertung nicht verzerren.",
                "ai_profile": "KI-Profil",
                "ai_profile_placeholder": "Nur für KI-Sitzungen",
                "ai_description": "KI-Beschreibung",
                "optimize_ai_description": "Optimize with AI",
                "optimizing_in_progress": "AI is optimizing the description. Please wait...",
                "optimize_error": "Failed to optimize the description. Please try again.",
                "ai_description_hint": "Das Schreiben eines effektiven KI-Prompts erfordert Erfahrung. Ein schlecht formulierter Prompt kann zu unvorhersehbarem Szenarioverhalten führen. Wenn Sie unsicher sind, nutzen Sie die Schaltfläche «Mit KI optimieren», probieren Sie die Szenariogenerierung aus oder wenden Sie sich an Ihren Manager.",
                "knowledge_base_header": "Wissensdatenbank",
                "knowledge_base_documents": "Wissensdatenbank-Dokumente",
                "knowledge_base_documents_hint": "Dokumente anhängen, um dem KI-Spieler Kontext bereitzustellen",
                "knowledge_base_no_documents": "Keine Dokumente verfügbar. Laden Sie Dokumente auf der Seite \"Wissensdatenbank\" hoch.",
                "knowledge_base_chunks": "{count} Abschnitte",
                "knowledge_base_purpose_voice": "KI-Sitzung",
                "knowledge_base_purpose_eval": "Bewertung"
            },
            "settings": {
                "title": "Einstellungen",
                "subtitle": "Szenariokonfiguration",
                "min_players": "Minimale Teilnehmer",
                "min_players_hint": "Nummer zwischen 2 und 20",
                "max_players": "Maximale Teilnehmer",
                "max_players_hint": "Nummer zwischen 2 und 20",
                "protocol_time": "Protokollzeit (min)",
                "protocol_time_hint": "Nummer zwischen 1 und 1440",
                "preparation_time": "Vorbereitungszeit (min)",
                "preparation_time_hint": "Nummer zwischen 0 und 1440. 0 - die Beschreibung ist sofort sichtbar",
                "game_duration": "Sitzungsdauer (min)",
                "game_duration_hint": "Nummer zwischen 1 und 60",
                "is_team": "Speilnamen für Teams",
                "is_camera_required": "Teilnehmerkameras sind erforderlich",
                "is_self_rated": "Teilnehmer können sich selbst bewerten",
                "is_each_other_rated": "Teilnehmer können sich gegenseitig bewerten",
                "is_expert_rated": "Expertenbewertung ist verfügbar",
                "is_ai_rated": "KI-Bewertung ist verfügbar",
                "show_results": "Ergebnisse anzeigen",
                "automatically": "automatisch",
                "manually": "manuell"
            },
            "parameters": {
                "title": "Parameter",
                "subtitle": "Teilnehmerparameter",
                "field_title": "Titel",
                "team_a": "Team A",
                "team_b": "Team B",
                "player_a": "Teilnehmer A",
                "player_b": "Teilnehmer B",
                "points": "Punkte",
                "ratio": "Verhältnis",
                "add": "Parameter hinzufügen"
            },
            "questions": {
                "title": "Fragen",
                "subtitle": "Fragen für Teilnehmer",
                "question": "Frage",
                "team": "Team",
                "team_placeholder": "Team auswählen",
                "answers": "Antworten",
                "points": "Punkte",
                "select_answers": "Antworten auswählen",
                "add_combination": "Kombination hinzufügen",
                "add_question": "Frage hinzufügen"
            },
            "next": "Nächste",
            "previous": "Vorherige",
            "save": "Speichern"
        },
        "saved": "Speilnamen gespeichert",
        "to_list": "Zurück zur Liste",
        "add_detail": "Speilnamen hinzufügen",
        "edit_detail": "Speilnamen bearbeiten"
    },
    "notifications": {
        "title": "Benachrichtigungen",
        "mark_unread": "Alle als ungelesen markieren",
        "mark_read": "Alle als gelesen markieren",
        "delete_all": "Alles löschen",
        "no_new": "Keine Benachrichtigungen gefunden",
        "system": "System",
        "evaluation": {
            "ready": {
                "subject": "Sitzung #:gameNumber Bewertung",
                "text": "Die Sitzung wurde von einem Experten bewertet"
            }
        },
        "game": {
            "created": {
                "game_assigned": "Sie haben eine zugewiesene Sitzung",
                "role": "Rolle:"
            },
            "proposal": {
                "subject": "Koordinierung der Sitzungszeit",
                "time": "Zeit:",
                "description": "Bitte bestätigen oder schlagen Sie eine eigene Option vor"
            },
            "agreed": {
                "subject": "Sitzungszeit vereinbart",
                "time": "Zeit:",
                "description": "Die Beschreibung und die Vorbereitungsmöglichkeiten werden :preparationTime Minuten vor dem Start verfügbar sein",
                "description_zero": "Sie können jetzt die Szenariobeschreibung überprüfen und sich vorbereiten"
            },
            "preparation": {
                "subject": "Vorbereitung für die Sitzung",
                "text": "Die Vorbereitung für die Sitzung ist verfügbar."
            },
            "started": {
                "subject": "Die Sitzung #:gameNumber hat begonnen",
                "text": "Treten Sie bei!"
            },
            "missed": {
                "subject": "Die Sitzung #:gameNumber wurde verpasst",
                "text": "Entschuldigung, Sie haben die Sitzung verpasst"
            },
            "completed": {
                "subject": "Sitzung #:gameNumber abgeschlossen",
                "text": "Erfolgreiche Sitzung"
            },
            "failed": {
                "subject": "Sitzung #:gameNumber fehlgeschlagen",
                "text": "Erfolgreich abgeschlossen"
            },
            "results": {
                "proposed": {
                    "subject": "Sitzungsprotokoll #:gameNumber vereinbart",
                    "text": "Einvernehmlichkeit verfügbar"
                },
                "declined": {
                    "subject": "Sitzungsprotokoll #:gameNumber abgelehnt",
                    "text": "Vorschlag abgelehnt"
                },
                "not_agreed": {
                    "subject": "Sitzung #:gameNumber: Die Parteien haben sich nicht geeinigt",
                    "text": "Der gegnerische Kapitän hat vermerkt, dass die Parteien sich nicht geeinigt haben. Die Sitzung wurde erfolglos beendet und die Ergebnisse wurden nicht gewertet."
                }
            },
            "meeting": {
                "ended-player": {
                    "subject": "Sitzungsbesprechung #:gameNumber beendet",
                    "text": "Bitte warten Sie auf die Ergebnisse."
                },
                "ended-captain": {
                    "subject": "Sitzungsbesprechung #:gameNumber beendet",
                    "text_fill": "Bitte füllen Sie das Protokoll aus.",
                    "text_wait": "Bitte warten Sie, bis das Protokoll ausgefüllt ist.",
                    "protocol_time": "Protokollzeit (minuten): :protocolTime"
                }
            }
        }
    },
    "profile": {
        "avatar_allowed": "Zulässige Formate: JPG, GIF oder PNG. Maximalgröße von 2MB",
        "avatar_label_choose": "Wählen",
        "avatar_label_your_avatar": "Ihr Avatar",
        "name": "Vorname",
        "last_name": "Nachname",
        "patronymic": "Vatersname",
        "phone": "Telefon",
        "timezone": "Zeitzone",
        "language": "Sprache",
        "country": "Land",
        "invalid_phone": "Falsche Telefonnummer",
        "save_changes": "Änderungen speichern",
        "account": "Konto",
        "security": "Sicherheit",
        "statistics": "Statistik",
        "notifications": "Benachrichtigungen",
        "change_password_title": "Passwort ändern",
        "change_password": "Passwort ändern",
        "current_password": "Aktuelles Passwort",
        "new_password": "Neues Passwort",
        "confirm_new_password": "Neues Passwort bestätigen",
        "password_requirements": "Passwortanforderungen:",
        "password_requirements_1": "Mindestens 8 Zeichen lang - je mehr, desto besser",
        "password_requirements_2": "Mindestens ein Kleinbuchstabe",
        "password_requirements_3": "Mindestens eine Zahl, ein Symbol oder ein Leerzeichen",
        "two_factor_title": "Zwei-Faktor-Authentifizierung",
        "two_factor_description": "Fügen Sie Ihrem Konto eine zusätzliche Sicherheitsebene hinzu",
        "two_factor_org_enforced": "Die Zwei-Faktor-Authentifizierung wird von Ihrer Organisation erzwungen",
        "two_factor_method": "Authentifizierungsmethode",
        "two_factor_disabled": "Deaktiviert",
        "two_factor_email": "E-Mail",
        "two_factor_sms": "SMS",
        "two_factor_save": "2FA-Einstellungen speichern"
    },
    "auth": {
        "password": "Passwort",
        "new_password": "Neues Passwort",
        "remember": "Erinnere dich an mich",
        "timezone": "Zeitzone",
        "forgot": "Passwort vergessen",
        "login": "Anmelden",
        "login_title": "Anmelden",
        "new_password_title": "Passwort ändern",
        "change_password": "Speichern",
        "country": "Land",
        "invalid_phone": "Falsche Telefonnummer",
        "privacy_policy_title": "Datenschutzerklärung",
        "privacy_policy_text": "Datenschutzerklärungstext...",
        "first_time": "Neu auf unserer Plattform?",
        "registration": "Konto erstellen",
        "forgot_title": "Passwort vergessen?",
        "forgot_description": "Geben Sie Ihre E-Mail ein und wir senden Ihnen Anweisungen zum Zurücksetzen Ihres Passworts",
        "send_reset_link": "Link zum Zurücksetzen senden",
        "back_to_login": "Zurück zur Anmeldung",
        "register": "Anmelden",
        "name": "Vorname",
        "last_name": "Nachname",
        "patronymic": "Vatersname",
        "phone": "Telefon",
        "enter_password": "Passwort eingeben",
        "confirm_password": "Passwort bestätigen",
        "not_first_time": "Hast du bereits ein Konto?",
        "agree_too": "Ich stimme zu",
        "privacy_policy": "Datenschutzerklärung & Nutzungsbedingungen",
        "accept": " Ich stimme zu ",
        "password_validation": "Das Feld muss mindestens einen Großbuchstaben, Kleinbuchstaben, Sonderzeichen und eine Ziffer mit mindestens 8 Zeichen enthalten",
        "password_confirm_error": "Die Bestätigung des Passwortbestätigungsfeldes stimmt nicht überein",
        "set_password": "Neues Passwort festlegen",
        "reset_password": "Passwort zurücksetzen",
        "for": "für",
        "sign_in_to_for": "Bei {app} für {org} anmelden",
        "registration_title": "Registrierung",
        "verify_title": "E-Mail-Bestätigung",
        "verify_head": "Bestätigen Sie Ihre E-Mail",
        "verify_description": "Aktivierungslink wurde an Ihre E-Mail-Adresse gesendet. Bitte folgen Sie dem Link, um fortzufahren.",
        "verify_new_link": "Ein neuer Bestätigungslink wurde an die bei der Registrierung angegebene E-Mail-Adresse gesendet.",
        "verify_send": "Bestätigungsmail erneut senden",
        "verify_spam": "Sie haben zu viele Anfragen gestellt, bitte versuchen Sie es in einer Minute erneut",
        "verify_logout": "Abmelden",
        "two_factor_title": "Zwei-Faktor-Authentifizierung",
        "two_factor_description_email": "Wir haben einen Bestätigungscode an Ihre E-Mail-Adresse gesendet. Bitte geben Sie den Code unten ein.",
        "two_factor_description_sms": "Wir haben einen Bestätigungscode an Ihre Telefonnummer gesendet. Bitte geben Sie den Code unten ein.",
        "two_factor_code_label": "Bestätigungscode",
        "two_factor_code_placeholder": "6-stelligen Code eingeben",
        "two_factor_verify": "Bestätigen",
        "two_factor_resend": "Code erneut senden",
        "two_factor_resend_success": "Ein neuer Code wurde gesendet",
        "two_factor_back": "Zurück zur Anmeldung"
    },
    "filepond": {
        "upload": "Hochladen",
        "upload_complete": "Hochladen abgeschlossen",
        "uploading": "Hochladen",
        "loading": "Laden",
        "tap_to_cancel": "antippen, um abzubrechen",
        "tap_to_undo": "antippen, um rückgängig zu machen",
        "upload_aborted": "Hochladen abgebrochen",
        "file_too_large": "Datei ist zu groß"
    },
    "text-editor": {
        "image": "Simply drag and drop your image in editor"
    },
    "webrtc": {
        "ready_to_start": "Bereit zum Starten",
        "connected": "Verbunden - Jetzt sprechen!",
        "connection_lost": "Verbindung verloren. Bitte versuchen Sie es erneut."
    },
    "device_settings": {
        "title": "Audio- und Videogeräteeinstellungen",
        "speaker": "Lautsprecher/Audioausgang",
        "refresh_devices": "Geräte aktualisieren",
        "speaker_switch_unsupported": "Lautsprecherumschaltung wird in diesem Browser nicht unterstützt"
    },
    "device_setup": {
        "mic_level": "Mikrofonpegel",
        "mic_on": "Ein",
        "mic_off": "Aus",
        "cam_on": "Ein",
        "cam_off": "Aus"
    },
    "device_test": {
        "title": "Audiogeräte testen",
        "speaker_test": "Lautsprecher-Test",
        "speaker_hint": "Klicken Sie auf die Schaltfläche, um Testtöne über Ihren ausgewählten Lautsprecher abzuspielen",
        "play_sound": "Testton abspielen",
        "playing": "Wird abgespielt...",
        "speaker_success": "Ton abgespielt ✓",
        "mic_test": "Mikrofon-Test",
        "mic_hint": "Klicken Sie auf die Schaltfläche und sprechen Sie in Ihr Mikrofon, um es zu testen",
        "volume_level": "Lautstärkepegel",
        "speak_now": "Sprechen Sie jetzt...",
        "seconds_short": "s",
        "start_mic_test": "Mikrofon testen",
        "testing": "Wird getestet...",
        "test_again": "Erneut testen",
        "mic_success": "Mikrofon funktioniert einwandfrei!",
        "mic_fail": "Mikrofonproblem erkannt",
        "mic_fail_hint": "Kein Ton erkannt. Bitte überprüfen Sie, ob Ihr Mikrofon angeschlossen, nicht stumm geschaltet und in den Einstellungen richtig ausgewählt ist."
    },
    "ai_assistant_types": {
        "type": "Typ",
        "negotiation": "Verhandlung",
        "feedback": "Feedback",
        "ai_profile": "KI-Sitzung"
    },
    "Login": "Eintreten",
    "UI Elements": "UI-Elemente",
    "Forms & Tables": "Formen & Tabellen",
    "Welcome": "Willkommen",
    "Pages": "Seiten",
    "Charts & Maps": "Diagramme & Karten",
    "Others": "Andere",
    "Typography": "Typografie",
    "Cards": "Karten",
    "Basic": "Grundlegend",
    "Advance": "Fortschritt",
    "Widgets": "Widgets",
    "Components": "Komponenten",
    "Alert": "Warnung",
    "Close Alert": "Warnung schließen",
    "Avatar": "Avatar",
    "Badge": "Abzeichen",
    "Button": "Taste",
    "Calendar": "Kalender",
    "Image": "Bild",
    "Pagination": "Seitennavigation",
    "Progress Circular": "Kreisfortschritt",
    "Progress Linear": "Linearer Fortschritt",
    "Autocomplete": "Vervollständigen",
    "Tooltip": "Tooltip",
    "Slider": "Schieberegler",
    "Date Time Picker": "Datum/Zeit-Auswahl",
    "Select": "Wählen",
    "Switch": "Schalter",
    "Checkbox": "Checkbox",
    "Radio": "Radio",
    "Textarea": "Textarea",
    "Rating": "Bewertung",
    "File Input": "Dateieingabe",
    "Otp Input": "Otp-Eingabe",
    "Form Layout": "Formularlayout",
    "Form Validation": "Formularvalidierung",
    "Charts": "Diagramme",
    "Apex Chart": "Apex-Diagramm",
    "Chartjs": "Chartjs",
    "Account Settings": "Kontoeinstellungen",
    "User Profile": "Benutzerprofil",
    "FAQ": "FAQ",
    "Dialog Examples": "Dialogbeispiele",
    "Pricing": "Preise",
    "List": "Liste",
    "Edit": "Bearbeiten",
    "Nav Levels": "Navigationsstufen",
    "Level 2.1": "Ebene 2.1",
    "Level 2.2": "Ebene 2.2",
    "Level 3.1": "Ebene 3.1",
    "Level 3.2": "Ebene 3.2",
    "Raise Support": "Unterstützung anfordern",
    "Documentation": "Dokumentation",
    "Dashboards": "Dashboards",
    "Analytics": "Auswertung",
    "Apps & Pages": "Apps & Seiten",
    "Email": "Email",
    "Chat": "Chat",
    "Invoice": "Rechnung",
    "Preview": "Vorschau",
    "Add": "Hinzufügen",
    "User": "Benutzer",
    "View": "Ansicht",
    "Login v1": "Anmelden v1",
    "Login v2": "Anmelden v2",
    "Register v1": "Anmelden v1",
    "Register v2": "Anmelden v2",
    "Register": "Registrieren",
    "Forget Password v1": "Passwort vergessen v1",
    "Forget Password v2": "Passwort vergessen v2",
    "Forgot Password v1": "Passwort vergessen v1",
    "Forgot Password v2": "Passwort vergessen v2",
    "Forgot Password": "Passwort vergessen",
    "Reset Password v1": "Passwort zurücksetzen v1",
    "Reset Password v2": "Passwort zurücksetzen v2",
    "Reset Password": "Passwort zurücksetzen",
    "Miscellaneous": "Sonstiges",
    "Coming Soon": "Kommt bald",
    "Not Authorized": "Nicht autorisiert",
    "Under Maintenance": "In Wartung",
    "Error": "Fehler",
    "Statistics": "Statistiken",
    "Actions": "Aktionen",
    "Access Control": "Zugriffskontrolle",
    "User Interface": "Benutzeroberfläche",
    "CRM": "CRM",
    "eCommerce": "E-Commerce",
    "Icons": "Symbole",
    "Chip": "Chip",
    "Dialog": "Dialog",
    "Expansion Panel": "Erweiterungsfeld",
    "Combobox": "Kombinationsfeld",
    "Textfield": "Textfeld",
    "Range Slider": "Bereichsregler",
    "Menu": "Menü",
    "Snackbar": "Snackbar",
    "Tabs": "Tabs",
    "Form Elements": "Formularelemente",
    "Form Layouts": "Formular-Layouts",
    "Authentication": "Authentifizierung",
    "Page Not Found - 404": "Seite nicht gefunden - 404",
    "Not Authorized - 401": "Nicht autorisiert - 401",
    "Server Error - 500": "Serverfehler - 500",
    "2": "2",
    "Forms": "Formulare",
    "Timeline": "Zeitleiste",
    "Disabled Menu": "Deaktiviertes Menü",
    "Help Center": "Hilfe-Center",
    "Verify Email": "E-Mail bestätigen",
    "Verify Email v1": "E-Mail bestätigen v1",
    "Verify Email v2": "E-Mail bestätigen v2",
    "Two Steps": "Zwei Schritte",
    "Two Steps v1": "Zwei Schritte v1",
    "Two Steps v2": "Zwei Schritte v2",
    "Custom Input": "Benutzerdefinierte Eingabe",
    "Extensions": "Erweiterungen",
    "Tour": "Runde",
    "Register Multi-Steps": "Mehrstufig registrieren",
    "Wizard Examples": "Assistent-Beispiele",
    "Checkout": "Kasse",
    "Create Deal": "Angebot erstellen",
    "Property Listing": "Immobilienauflistung",
    "Roles & Permissions": "Rollen & Berechtigungen",
    "Roles": "Rollen",
    "Simple Table": "Einfache Tabelle",
    "Tables": "Tabellen",
    "Data Table": "Datentabelle",
    "Permissions": "Berechtigungen",
    "Apps": "Apps",
    "Misc": "Sonstiges",
    "Wizard Pages": "Assistentenseiten",
    "Form Wizard": "Form-Assistent",
    "Numbered": "Nummeriert",
    "3": "3",
    "ecommerce": "E-Commerce",
    "Ecommerce": "E-Commerce",
    "Editors": "Editoren",
    "Front Pages": "Vorderseiten",
    "Landing": "Landeseite",
    "checkout": "Kasse",
    "Payment": "Zahlung",
    "Swiper": "Wischer",
    "Product": "Produkt",
    "Category": "Kategorie",
    "Order": "Bestellung",
    "Details": "Details",
    "Customer": "Kunde",
    "Manage Review": "Bewertungen verwalten",
    "Referrals": "Empfehlungen",
    "Settings": "Einstellungen",
    "Overview": "Überblick",
    "My Course": "Mein Kurs",
    "Course Details": "Kursdetails",
    "Academy": "Akademie",
    "Logistics": "Logistik",
    "Dashboard": "Dashboard",
    "Fleet": "Flotte",
    "5": "5",
    "10": "10",
    "20": "20",
    "25": "25",
    "50": "50",
    "100": "100",
    "skill_reports": {
        "skill_development_report": "Kompetenzentwicklungsbericht",
        "generate": "Generieren",
        "generate_description": "Einen umfassenden Kompetenzentwicklungsbericht für einen ausgewählten Zeitraum erstellen",
        "manager_description": "Kompetenzentwicklungsberichte für Mitarbeiter in Ihrer Organisation erstellen",
        "date": "Datum",
        "competence": "Kompetenz",
        "period": "Zeitraum",
        "status_label": "Status",
        "actions": "Aktionen",
        "employee": "Mitarbeiter",
        "view": "Bericht anzeigen",
        "download_pdf": "PDF herunterladen",
        "no_reports": "Noch keine Berichte erstellt",
        "data_not_available": "Berichtsdaten sind noch nicht verfügbar",
        "generation_failed": "Berichterstellung fehlgeschlagen",
        "retry": "Erneut versuchen",
        "rate_limit_exceeded": "Limit für die Berichterstellung erreicht. Bitte versuchen Sie es später erneut.",
        "too_many_pending": "Sie haben zu viele Berichte in Bearbeitung. Bitte warten Sie, bis diese abgeschlossen sind.",
        "no_games_for_report": "Für den ausgewählten Zeitraum und die Kompetenz wurden keine abgeschlossenen Sitzungen gefunden. Der Bericht kann nicht erstellt werden.",
        "report_already_exists": "Ein Bericht mit diesen Parametern existiert bereits. Überprüfen Sie die Liste unten.",
        "period_too_long": "Der Berichtszeitraum darf ein Jahr nicht überschreiten.",
        "invalid_parameters": "Prüfen Sie Kompetenz und Zeitraum",
        "filter_by_employee": "Nach Mitarbeiter filtern...",
        "batch": {
            "mode_single": "Einzelbericht",
            "mode_batch": "Stapel",
            "load_employees": "Mitarbeiter anzeigen",
            "sessions": "Sitzungen",
            "no_candidates": "Keine Mitarbeiter mit abgeschlossenen Sitzungen für die gewählte Kompetenz und den Zeitraum",
            "generate_selected": "Erstellen ({count})",
            "selected_limit": "Es können höchstens {max} Mitarbeiter gleichzeitig ausgewählt werden",
            "progress": "{ready} von {total} fertig",
            "failed_count": "Fehler: {count}",
            "status_unknown": "Status unbekannt",
            "status_unknown_hint": "Der Bericht wurde in der Liste nicht gefunden — sehen Sie in der Berichtstabelle unten nach",
            "reused": "Wiederverwendete Berichte: {count} — in den letzten {hours} Std. erstellt und nicht neu generiert",
            "reused_badge": "Wiederverwendet",
            "reused_on": "Erstellt am {date}",
            "download_all": "Alle herunterladen",
            "toggle_details": "Stapelinhalt anzeigen",
            "dismiss_confirm": "Dieser Stapel wird noch erstellt. Vom Bildschirm entfernen? Fortschritt und die Schaltfläche „Alle herunterladen“ gehen verloren, die Berichte bleiben in der Liste unten.",
            "archive_unavailable": "Das Archiv konnte nicht erstellt werden: Einige Berichte sind noch nicht fertig oder nicht mehr verfügbar",
            "archive_failed": "Das Archiv konnte nicht heruntergeladen werden",
            "archive_building": "Archiv wird erstellt…",
            "archive_build_failed": "Das Archiv konnte nicht erstellt werden. Bitte erneut versuchen.",
            "candidates_failed": "Die Mitarbeiterliste konnte nicht geladen werden",
            "stale_selection": "Einige der ausgewählten Mitarbeiter sind nicht mehr verfügbar. Die Liste wurde aktualisiert — bitte erneut auswählen."
        },
        "quota": {
            "remaining_hour": "Berichtslimit: {limit} pro Stunde. Sie können jetzt noch {remaining} weitere anfordern. Wählen Sie weniger Mitarbeiter oder versuchen Sie es um {time} erneut.",
            "remaining_day": "Berichtslimit: {limit} pro Tag. Sie können jetzt noch {remaining} weitere anfordern. Wählen Sie weniger Mitarbeiter oder versuchen Sie es um {time} erneut.",
            "exhausted_hour": "Berichtslimit ({limit} pro Stunde) erreicht. Es wird um {time} zurückgesetzt.",
            "exhausted_day": "Berichtslimit ({limit} pro Tag) erreicht. Es wird um {time} zurückgesetzt.",
            "too_large_hour": "Berichtslimit: {limit} pro Stunde. Wählen Sie weniger Mitarbeiter.",
            "too_large_day": "Berichtslimit: {limit} pro Tag. Wählen Sie weniger Mitarbeiter."
        },
        "status": {
            "pending": "Ausstehend",
            "collecting_data": "Daten werden gesammelt...",
            "analyzing": "KI-Analyse...",
            "generating_pdf": "PDF wird erstellt...",
            "ready": "Bereit",
            "failed": "Fehlgeschlagen"
        },
        "report": {
            "kicker": "Bericht zur Kompetenzentwicklung",
            "position": "Position",
            "department": "Abteilung",
            "period": "Zeitraum",
            "games_count": "Durchgeführte Sitzungen",
            "not_specified_f": "Nicht angegeben",
            "not_specified_n": "Nicht angegeben",
            "fig": {
                "your_average": "Ihre durchschnittliche Punktzahl",
                "company_average": "Unternehmensdurchschnitt",
                "participants": "Teilnehmende im Zeitraum",
                "skills_count": "Bewertete Fähigkeiten"
            },
            "sec": {
                "profile": "Kompetenzprofil",
                "trend": "Verlauf über die Sitzungen",
                "strengths": "Worauf Sie aufbauen können",
                "priorities": "Drei Entwicklungsprioritäten",
                "skills": "Analyse nach Fähigkeiten",
                "plan": "Plan für drei Monate"
            },
            "legend": {
                "you": "Ihre Punktzahl",
                "company": "Unternehmensdurchschnitt"
            },
            "dotplot_caption": "Abweichung vom Durchschnitt — vom größten Vorsprung zum größten Rückstand",
            "trend_disclaimer": "Die Punktzahlen einzelner Sitzungen sind nicht direkt vergleichbar: Die Fälle unterscheiden sich von Sitzung zu Sitzung im Schwierigkeitsgrad. Ein niedrigerer Wert bedeutet für sich genommen keinen Rückgang der Fähigkeit — die Grafik ist eine Beobachtung, kein Urteil.",
            "no_comparison": "Ein Vergleich mit dem Unternehmensdurchschnitt ist nicht möglich: Im Zeitraum haben weniger als drei Personen Sitzungen zu dieser Kompetenz absolviert. Der Bericht beruht auf absoluten Punktzahlen.",
            "skill": {
                "works": "Was gelingt",
                "blocks": "Was im Weg steht",
                "actions": "Was zu tun ist",
                "out_of_ten": "von 10",
                "company_short": "Unternehmen"
            },
            "level": {
                "outstanding": "Herausragend",
                "strength": "Stärke",
                "meets_standard": "Auf Unternehmensniveau",
                "needs_attention": "Erfordert Aufmerksamkeit",
                "needs_development": "Entwicklungsfeld"
            },
            "plan": {
                "month": "Monat",
                "goals": "Ziele",
                "actions": "Maßnahmen"
            },
            "colophon": {
                "built_on": "Der Bericht beruht auf Sitzungen im Zeitraum {from} — {to}. Sitzungen insgesamt: {count}.",
                "comparison": "Verglichen wird mit dem Unternehmensdurchschnitt desselben Zeitraums. Teilnehmende: {count}."
            }
        }
    },
    "maintenance": "Wartung",
    "maintenance-page": {
        "title": "Wartungseinstellungen",
        "notification_section": "Globale Benachrichtigung",
        "notification_placeholder": "Benachrichtigungstext für alle Benutzer eingeben",
        "notification_hint": "Diese Nachricht wird allen authentifizierten Benutzern als Warnung angezeigt",
        "games_section": "Sitzungsblockierung",
        "games_blocked_label": "Neue Sitzungen blockieren",
        "games_blocked_hint": "Wenn aktiviert, können Benutzer keine neuen Sitzungen erstellen oder starten. Bestehende Sitzungen können weiterhin betreten werden.",
        "save": "Speichern",
        "clear": "Löschen",
        "clear_confirm": "Möchten Sie die Benachrichtigung wirklich löschen?",
        "last_updated": "Zuletzt aktualisiert",
        "updated_by": "von",
        "games_blocked_message": "Wir entschuldigen uns für die Unannehmlichkeiten. Die Plattform wird derzeit gewartet. Sitzungen sind vorübergehend nicht verfügbar."
    },
    "$vuetify": {
        "badge": "Abzeichen",
        "noDataText": "Keine Daten verfügbar",
        "close": "Schließen",
        "open": "öffnen",
        "carousel": {
            "ariaLabel": {
                "delimiter": "Begrenzer"
            }
        },
        "dataFooter": {
            "itemsPerPageText": "Elemente pro Seite:",
            "itemsPerPageAll": "Alle",
            "pageText": "{0}-{1} von {2}",
            "firstPage": "Erste Seite",
            "prevPage": "Vorherige Seite",
            "nextPage": "Nächste Seite",
            "lastPage": "Letzte Seite"
        },
        "pagination": {
            "ariaLabel": {
                "root": "Stamm",
                "previous": "vorherige",
                "next": "nächste",
                "first": "erste",
                "last": "letzte",
                "currentPage": "aktuelleSeite",
                "page": "Seite"
            }
        },
        "input": {
            "clear": "löschen",
            "appendAction": "anhängenAktion",
            "prependAction": "vorpindAktion",
            "counterSize": "ZählerGröße",
            "otp": "otp"
        },
        "fileInput": {
            "counterSize": "ZählerGröße"
        },
        "rating": {
            "ariaLabel": {
                "item": "Element"
            }
        }
    },
    "api-tokens": "API-Tokens",
    "api-tokens-page": {
        "select_user": "Benutzer",
        "select_user_hint": "Wählen Sie einen Benutzer aus, um seine API-Tokens anzuzeigen und zu verwalten.",
        "no_users_found": "Keine Benutzer gefunden",
        "no_tokens": "Dieser Benutzer hat keine API-Tokens.",
        "token_name": "Name",
        "abilities": "Berechtigungen",
        "ability": "Berechtigung",
        "created_at": "Erstellt am",
        "last_used_at": "Zuletzt verwendet am",
        "expires_at": "Läuft ab am",
        "actions": " ",
        "issue_token": "Token ausstellen",
        "issue": "Ausstellen",
        "issue_failed": "Token konnte nicht ausgestellt werden",
        "token": "Token",
        "plaintext_warning": "Kopieren Sie diesen Token jetzt — er wird nicht erneut angezeigt.",
        "revoke": "Widerrufen",
        "revoke_confirm": "Sind Sie sicher, dass Sie diesen Token widerrufen möchten? Integrationen, die ihn verwenden, werden nicht mehr funktionieren."
    },
    "subscription": {
        "current_plan": "Aktueller Plan",
        "expires_at": "Läuft ab: {date}",
        "no_active_plan": "Kein aktiver Abonnementplan",
        "quota_warning": "Wenig Kontingent verbleibend",
        "regular_games": "Reguläre Sitzungen",
        "ai_games": "KI-Sitzungen",
        "any_games": "Beliebige Sitzungen",
        "used_of": "{used} von {limit}",
        "remaining": "{count} verbleibend",
        "quota_exceeded": "Funktionskontingent überschritten",
        "tickets_only": "Kreditpakete",
        "session_package": "Sitzungspaket",
        "games_available": "Sitzungen",
        "users": "Benutzer",
        "active_users": "Aktive Benutzer",
        "active_tickets": "Kreditpakete",
        "ticket_charges": "{charges} Kredite",
        "ticket_no_expiry": "Kein Ablaufdatum",
        "unlimited": "Unbegrenzt",
        "no_game_limits": "Keine Einschränkungen bei der Anzahl der Sitzungen"
    },
    "knowledge-base-page": {
        "provider-unsupported": "Die Wissensdatenbank ist mit dem aktuellen KI-Anbieter Ihrer Organisation nicht verfügbar."
    },
    "candidate-page": {
        "document_title": "Interview",
        "greeting": "Guten Tag, {name}!",
        "intro_lead": "{organization} lädt Sie zu einem Interview mit einem virtuellen Gesprächspartner für die Stelle „{vacancy}“ ein.",
        "duration": "Das Interview dauert etwa {minutes} Minuten.",
        "requirements_title": "Was Sie benötigen",
        "requirement_mic": "Ein funktionierendes Mikrofon, idealerweise ein Headset",
        "requirement_camera_required": "Eine eingeschaltete Kamera: Sie ist für dieses Interview erforderlich",
        "requirement_camera_optional": "Eine Kamera ist optional, macht das Gespräch aber natürlicher",
        "requirement_browser": "Ein Computer mit aktuellem Chrome, Edge oder Safari",
        "requirement_network": "Eine stabile Internetverbindung und ein ruhiger Ort, an dem Sie ungestört sind",
        "continue": "Weiter",
        "consent": {
            "accept": "Ich habe den Text gelesen und stimme der Verarbeitung meiner personenbezogenen Daten zu",
            "back": "Zurück",
            "start": "Interview starten"
        },
        "terminal": {
            "finished": {
                "title": "Vielen Dank!",
                "text": "Das Interview ist beendet, das Ergebnis wurde an den Recruiter übermittelt — er wird sich bei Ihnen melden. Sie können diese Seite jetzt schließen."
            },
            "already_completed": {
                "title": "Interview bereits abgeschlossen",
                "text": "Über diesen Link wurde bereits ein Interview abgeschlossen. Wenn Sie es erneut durchführen müssen, wenden Sie sich an den Recruiter."
            },
            "not_found": {
                "title": "Link nicht gefunden",
                "text": "Die Adresse enthält möglicherweise einen Tippfehler, oder der Link ist nicht mehr gültig. Prüfen Sie die E-Mail des Recruiters oder wenden Sie sich an ihn."
            },
            "session_conflict": {
                "title": "Sie sind mit einem anderen Konto angemeldet",
                "text": "Melden Sie sich vom aktuellen Konto ab oder öffnen Sie den Link in einem privaten Browserfenster."
            },
            "link_revoked": {
                "title": "Der Zugang über diesen Link wurde gesperrt",
                "text": "Der Recruiter hat diesen Link widerrufen. Wenden Sie sich an ihn, um einen neuen zu erhalten."
            },
            "link_expired": {
                "title": "Der Link ist abgelaufen",
                "text": "Wenden Sie sich an den Recruiter, damit er einen neuen Link ausstellt."
            },
            "attempts_exhausted": {
                "title": "Keine Versuche mehr übrig",
                "text": "Alle verfügbaren Versuche für diesen Link wurden genutzt. Wenden Sie sich an den Recruiter."
            },
            "unavailable": {
                "title": "Start momentan nicht möglich",
                "text": "Versuchen Sie es später erneut oder wenden Sie sich an den Recruiter."
            },
            "rate_limited": {
                "title": "Zu viele Versuche",
                "text": "Warten Sie eine Minute und laden Sie die Seite neu."
            },
            "aborted": {
                "title": "Das Interview wurde nicht gestartet",
                "text": "Laden Sie die Seite neu und versuchen Sie es erneut. Wenn das nicht hilft, wenden Sie sich an den Recruiter."
            },
            "generic": {
                "title": "Etwas ist schiefgelaufen",
                "text": "Laden Sie die Seite neu und versuchen Sie es erneut. Wenn das nicht hilft, wenden Sie sich an den Recruiter."
            }
        }
    },
    "recruiting-page": {
        "title": "Recruiting",
        "create": "Neue Stelle",
        "edit": "Stelle bearbeiten",
        "empty": "Noch keine Stellen",
        "load_error": "Die Stellenliste konnte nicht geladen werden",
        "retry": "Erneut versuchen",
        "back": "Zurück zu den Stellen",
        "open": "Kandidaten",
        "archive": "Archivieren",
        "no_expiry": "Kein Ablaufdatum",
        "confirm_archive": "Diese Stelle archivieren? Sie können dafür keine Links mehr ausstellen.",
        "headers": {
            "title": "Stelle",
            "scenario": "Szenario",
            "status": "Status",
            "expires_at": "Gültig bis",
            "actions": "Aktionen"
        },
        "status": {
            "draft": "Entwurf",
            "active": "Aktiv",
            "archived": "Archiviert"
        },
        "dialog": {
            "title_label": "Stellenbezeichnung",
            "scenario_label": "Interview-Szenario",
            "scenario_placeholder": "Szenario für das KI-Interview auswählen",
            "scenario_hint": "Es werden nur Szenarien angezeigt, die für eine Sitzung gegen die KI geeignet sind",
            "status_label": "Status",
            "expires_label": "Gültig bis",
            "expires_hint": "Leer lassen für kein Ablaufdatum",
            "save": "Speichern",
            "cancel": "Abbrechen"
        },
        "messages": {
            "created": "Stelle erstellt",
            "updated": "Stelle aktualisiert",
            "archived": "Stelle archiviert",
            "revoked": "Link widerrufen",
            "attempt_granted": "Ein weiterer Versuch gewährt",
            "copied": "Link kopiert",
            "error": "Etwas ist schiefgelaufen"
        },
        "candidates": {
            "title": "Kandidaten",
            "empty": "Für diese Stelle wurden noch keine Links ausgestellt",
            "load_error": "Die Kandidatenliste konnte nicht geladen werden",
            "issue": "Link ausstellen",
            "import": "Aus Datei importieren",
            "expired": "Abgelaufen",
            "no_games": "Interview nicht gestartet",
            "attempts": "{used} von {allowed}",
            "revoke": "Link widerrufen",
            "extra_attempt": "Weiteren Versuch gewähren",
            "open_result": "Interviewergebnis öffnen",
            "confirm_revoke": "Diesen Kandidatenlink widerrufen? Der Zugriff wird sofort entzogen, auch auf ein laufendes Interview.",
            "confirm_extra_attempt": "Diesem Kandidaten einen weiteren Versuch gewähren?",
            "headers": {
                "candidate": "Kandidat",
                "link_status": "Link",
                "invite": "Einladung",
                "game_status": "Interview",
                "attempts": "Versuche",
                "expires_at": "Link gültig bis",
                "actions": "Aktionen"
            },
            "link_status": {
                "created": "Ausgestellt",
                "opened": "Geöffnet",
                "in_progress": "Interview läuft",
                "completed": "Interview abgeschlossen",
                "revoked": "Widerrufen"
            },
            "invite_status": {
                "not_sent": "Nicht gesendet",
                "queued": "In Warteschlange",
                "sent": "Gesendet",
                "failed": "Senden fehlgeschlagen"
            },
            "invite_sent_at": "Vom Mailservice am {date} angenommen",
            "invite_failure": {
                "rejected": "Der Mailservice hat die E-Mail abgelehnt — senden Sie den Link selbst an den Kandidaten",
                "transport": "Senden fehlgeschlagen — senden Sie den Link selbst an den Kandidaten",
                "revoked": "Der Link wurde widerrufen",
                "sending_disabled": "Der E-Mail-Versand ist ausgeschaltet",
                "blocked": "Die Adresse steht in der Sperrliste — senden Sie den Link selbst an den Kandidaten"
            }
        },
        "issue_dialog": {
            "title": "Persönlichen Link ausstellen",
            "name": "Vorname",
            "last_name": "Nachname",
            "email": "E-Mail",
            "phone": "Telefon",
            "attempts": "Erlaubte Versuche",
            "expires_at": "Link gültig bis",
            "expires_hint": "Leer lassen, um die Frist der Stelle zu übernehmen",
            "submit": "Link ausstellen",
            "close": "Schließen",
            "result_title": "Link ausgestellt",
            "warning": "Kopieren Sie den Link jetzt — er wird nur einmal angezeigt. Gespeichert wird nur sein Hash, der Link kann also nicht wiederhergestellt werden: Ein verlorener Link muss widerrufen und neu ausgestellt werden.",
            "copy": "Kopieren",
            "copied": "Kopiert",
            "send_invite": "Einladung an {email} senden",
            "send_invite_no_email": "Einladung per E-Mail senden",
            "send_invite_blocked": "Diese Adresse steht in der Sperrliste — die E-Mail wird nicht gesendet",
            "invite_queued": "Einladung für {email} in die Warteschlange gestellt",
            "invite_blocked": "Einladung nicht gesendet: {email} steht in der Sperrliste. Senden Sie den Link selbst an den Kandidaten"
        },
        "import_dialog": {
            "title": "Kandidaten importieren",
            "subtitle": "Jede Zeile der Datei wird zu einem Kandidaten und einem persönlichen Link.",
            "file": "Datei mit Kandidatenliste",
            "columns": "Spalten: Vorname, Nachname, E-Mail, Telefon",
            "limits": "XLSX oder CSV (Semikolon), bis 200 Zeilen und 10 MB",
            "size_error": "Die Datei ist größer als 10 MB",
            "download_example": "Vorlage herunterladen",
            "note_title": "Die Links sind nur in der heruntergeladenen Datei sichtbar",
            "note_text": "Die Datei wird sofort nach Abschluss des Imports heruntergeladen. Gespeichert werden nur die Hashes der Links, ein zweiter Export ist nicht möglich — bewahren Sie die Datei auf.",
            "submit": "Importieren",
            "cancel": "Abbrechen",
            "result_title": "Links ausgestellt",
            "result": "Ausgestellte Links: {count}. Die Datei wurde heruntergeladen.",
            "invites_blocked": "Einladungen nicht gesendet: {count}. Diese Adressen stehen in der Sperrliste — senden Sie die Links selbst an diese Kandidaten.",
            "saved_title": "Bewahren Sie die heruntergeladene Datei auf",
            "saved_text": "Sie ist die einzige Kopie dieser Links: In der Datenbank werden nur ihre Hashes gespeichert. Ein verlorener Link kann nur widerrufen und neu ausgestellt werden.",
            "download_again": "Datei erneut herunterladen",
            "errors_title": "Abgelehnte Zeilen",
            "error_row": "Zeile {row}: {error}",
            "errors_truncated": "…und {count} weitere abgelehnte Zeilen. Die ersten 50 werden oben angezeigt.",
            "send_invites": "Einladungen per E-Mail an die Kandidaten senden",
            "send_invites_hint": "Kandidaten ohne E-Mail-Adresse erhalten keine Einladung"
        }
    },
    "ai-reports": "KI-Berichte",
    "ai-reports-page": {
        "title": "KI-Berichte",
        "subtitle": "Beschreiben Sie den Bericht in eigenen Worten – wir erstellen die Spezifikation, zeigen eine Vorschau und exportieren nach Excel.",
        "status": {
            "draft": "Entwurf",
            "pending": "Wird erstellt",
            "ready": "Fertig",
            "failed": "Fehlgeschlagen"
        },
        "list": {
            "title": "Meine Berichte",
            "new": "Neuer Bericht",
            "empty": "Noch keine Berichte. Klicken Sie auf „Neuer Bericht“ und beschreiben Sie, was gezeigt werden soll.",
            "untitled": "Ohne Titel",
            "delete": "Bericht löschen",
            "delete_confirm": "Diesen Bericht zusammen mit der erstellten Datei löschen?",
            "deleted": "Bericht gelöscht"
        },
        "dialog": {
            "title": "Dialog",
            "open_dictionary": "Datenverzeichnis",
            "placeholder": "Zum Beispiel: wie viele Spiele hat jede Abteilung im letzten Quartal durchgeführt",
            "send": "Senden",
            "empty_title": "Was soll der Bericht zeigen?",
            "empty_text": "Beschreiben Sie es in normalen Worten: welche Daten, für welchen Zeitraum und in welcher Aufschlüsselung. Falls etwas fehlt, frage ich nach.",
            "examples_title": "Zum Beispiel:",
            "examples": {
                "e1": "Wie viele Spiele hat jede Abteilung im letzten Quartal durchgeführt",
                "e2": "Durchschnittliche Kompetenzbewertung in der Vertriebsabteilung für 2026",
                "e3": "Mitarbeiter, die seit über einem Monat nicht gespielt haben",
                "e4": "Kandidaten nach Stelle und Linkstatus der letzten 30 Tage"
            },
            "thinking": "Bericht wird erstellt…",
            "waiting_hint": "Die Antwort erscheint hier von selbst — die Seite muss nicht neu geladen werden.",
            "retry": "Erneut versuchen",
            "dismiss": "Ausblenden",
            "spec_ready": "Der Bericht ist fertig gestellt – prüfen Sie die Vorschau unten und erstellen Sie die Datei.",
            "stuck_title": "Wir scheinen uns im Kreis zu drehen",
            "stuck_text": "Öffnen Sie das Datenverzeichnis und formulieren Sie die Anfrage mit dessen Begriffen neu – das geht schneller als eine weitere Rückfrage zu beantworten.",
            "rejected_title": "Dieser Bericht kann noch nicht erstellt werden",
            "reason": {
                "no_such_measure": "Diese Kennzahl gibt es in unseren Daten nicht. Prüfen Sie die Liste der Kennzahlen im Datenverzeichnis.",
                "no_such_field": "Dieses Feld gibt es in unseren Daten nicht. Prüfen Sie die Liste der Felder im Datenverzeichnis.",
                "cross_dataset": "Die Anfrage benötigt Daten aus zwei Datensätzen gleichzeitig. Teilen Sie sie in zwei Berichte auf.",
                "window_function": "Anteile am Gesamtwert, Ranglistenplätze und der Vergleich mit dem Vorzeitraum werden noch nicht unterstützt.",
                "other": "Die Anfrage geht über die verfügbaren Daten hinaus. Prüfen Sie das Datenverzeichnis und versuchen Sie eine andere Formulierung."
            },
            "usage": {
                "employees": "keine Mitarbeiter | {n} Mitarbeiter | {n} Mitarbeiter",
                "games": "keine Spiele | {n} Spiel | {n} Spiele",
                "scenarios": "keine Szenarien | {n} Szenario | {n} Szenarien",
                "evaluations": "keine Bewertungen | {n} Bewertung | {n} Bewertungen",
                "candidates": "keine Kandidaten | {n} Kandidat | {n} Kandidaten"
            },
            "option_created_at": "hinzugefügt am {date}"
        },
        "preview": {
            "title": "Vorschau",
            "no_report": "Wählen Sie links einen Bericht aus oder starten Sie einen neuen.",
            "no_spec": "Beschreiben Sie den Bericht im Dialog – die Vorschau erscheint, sobald die Anfrage verstanden wurde.",
            "spec_title": "Was der Bericht enthalten wird",
            "rows_hint": "Die ersten {count} Zeilen werden angezeigt",
            "total": "Zeilen insgesamt: {count}",
            "zero_rows": "Diese Anfrage liefert keine einzige Zeile. Erweitern Sie den Zeitraum oder entfernen Sie Filter – eine leere Datei zu erstellen hat keinen Sinn.",
            "zero_rows_hint": "Prüfen Sie die Filterwerte – möglicherweise gibt es dafür keine Daten",
            "duplicate_rows": "Einige Zeilen in der Vorschau sind identisch: Die gewählten Spalten unterscheiden die Einträge dieses Datensatzes nicht. Prüfen Sie, was eine Zeile hier tatsächlich bedeutet — möglicherweise fehlt eine unterscheidende Spalte.",
            "too_many_rows": "Der Bericht enthält {count} Zeilen, das Maximum ist {max}. Grenzen Sie den Zeitraum ein oder fügen Sie Filter hinzu: Bei Überschreitung der Obergrenze wird die Datei gar nicht erst erstellt statt gekürzt.",
            "generate": "Datei erstellen",
            "regenerate": "Erneut erstellen",
            "queued": "Die Datei wird erstellt – die Karte aktualisiert sich von selbst, sobald sie fertig ist.",
            "failed": "Der Bericht konnte nicht erstellt werden",
            "download": ".xlsx herunterladen",
            "downloads": "Downloads: {count}",
            "ttl_warning": "Die Datei wird {days} Tage lang aufbewahrt und dann gelöscht – laden Sie sie gleich herunter.",
            "expires_at": "Verfügbar bis {date}",
            "expired": "Die Datei wurde nach Ablauf der Aufbewahrungsfrist gelöscht – erstellen Sie den Bericht erneut."
        },
        "spec": {
            "dataset": "Daten",
            "columns": "Spalten",
            "measures": "Kennzahlen",
            "group_by": "Aufschlüsselung",
            "period": "Zeitraum",
            "period_value": "{field}: von {from} bis {to}",
            "period_all": "Gesamter verfügbarer Zeitraum",
            "filters": "Filter",
            "having": "Bedingungen für Kennzahlen",
            "sort": "Sortierung",
            "limit": "Zeilenbegrenzung",
            "limit_value": "erste {count} Zeilen",
            "granularity": {
                "year": "nach Jahr",
                "quarter": "nach Quartal",
                "month": "nach Monat",
                "week": "nach Woche",
                "day": "nach Tag",
                "dow": "nach Wochentag"
            },
            "dir": {
                "asc": "aufsteigend",
                "desc": "absteigend"
            },
            "filter": {
                "equals": "{field} — {value}",
                "not_equals": "{field} — nicht {value}",
                "in": "{field} — eines von: {value}",
                "not_in": "{field} — außer: {value}",
                "gt": "{field} größer als {value}",
                "gte": "{field} mindestens {value}",
                "lt": "{field} kleiner als {value}",
                "lte": "{field} höchstens {value}",
                "contains": "{field} enthält „{value}“",
                "between": "{field} — von {from} bis {to}",
                "is_null": "{field} ist nicht ausgefüllt",
                "is_not_null": "{field} ist ausgefüllt"
            }
        },
        "value": {
            "yes": "Ja",
            "no": "Nein"
        },
        "dictionary": {
            "title": "Datenverzeichnis",
            "subtitle": "Alles, was in einen Bericht aufgenommen werden kann. Die Liste ist live: Es ist dieselbe, aus der die Spezifikation erstellt wird.",
            "fields": "Felder",
            "measures": "Kennzahlen",
            "values": "Werte",
            "show_values": "Werte Ihrer Organisation anzeigen",
            "hide_values": "Werte ausblenden",
            "values_error": "Die Werte konnten nicht geladen werden – versuchen Sie es erneut.",
            "values_empty": "Ihre Organisation hat für dieses Feld noch keine Werte.",
            "limits": {
                "title": "Was ein Bericht nicht kann",
                "pivot": "Eine Kreuztabelle mit einer Spalte je Teilnehmer oder je Frage lässt sich nicht erstellen. Fordern Sie stattdessen die lange Form an: eine Zeile je Kombination aus Teilnehmer und Frage.",
                "window": "Veränderung von Monat zu Monat, Anteil am Gesamtwert, Platz im Ranking und „die drei Besten je Abteilung“ liegen außerhalb der Möglichkeiten. Nehmen Sie die Aufschlüsselung nach Monaten und rechnen Sie den Rest in Excel aus.",
                "missing": "Was das System nicht speichert, erscheint auch nicht im Bericht: Gehälter, NPS und andere Daten aus anderen Systemen tauchen unter keinem Namen auf."
            },
            "empty": "Das Datenverzeichnis ist leer – wenden Sie sich an Ihren Administrator.",
            "close": "Schließen"
        },
        "errors": {
            "generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
            "detail": "Nicht verstanden: {value}",
            "rate_limit": "Zu viele Anfragen. Warten Sie eine Minute und versuchen Sie es erneut.",
            "download": "Die Datei konnte nicht heruntergeladen werden.",
            "turn_failed": "Die Antwort konnte nicht abgerufen werden. Senden Sie die Anfrage erneut.",
            "turn_stuck_in_queue": "Die Anfrage wurde gar nicht erst bearbeitet — sie hat zu lange in der Warteschlange gewartet. Senden Sie sie erneut.",
            "unknown_resolution": "Diese Option ist veraltet — der Bericht hat sich inzwischen geändert. Öffnen Sie ihn erneut und präzisieren Sie Ihre Anfrage."
        }
    },
    "externalLaunch": {
        "document_title": "Übungssitzung",
        "intro": {
            "title": "Übungsgespräch",
            "lead": "Gleich sprechen Sie mit einem virtuellen Gesprächspartner. Das Gespräch wird aufgezeichnet und ausgewertet, das Ergebnis geht an Ihr Lernsystem zurück.",
            "requirements_title": "Was Sie benötigen",
            "requirement_mic": "Ein funktionierendes Mikrofon, idealerweise ein Headset",
            "requirement_camera": "Eine Kamera ist optional, macht das Gespräch aber natürlicher",
            "requirement_browser": "Ein Computer mit aktuellem Chrome, Edge oder Safari",
            "requirement_network": "Eine stabile Internetverbindung und ein ruhiger Ort, an dem Sie ungestört sind",
            "start": "Starten"
        },
        "relaunch_hint": "Kehren Sie zu Ihrem Lernsystem zurück und öffnen Sie das Material erneut.",
        "saving": "Ergebnis wird gespeichert…",
        "review": {
            "document_title": "Sitzungsauswertung",
            "attempt": "Versuch {number}",
            "result": {
                "passed": "Bestanden",
                "failed": "Nicht bestanden",
                "pending": "Noch nicht bewertet"
            },
            "score_of_100": "{score} von 100",
            "threshold": "Bestehensgrenze: {threshold}",
            "skills_title": "Fähigkeiten und Empfehlungen",
            "skills_empty": "Für diesen Versuch gibt es noch keine Rückmeldung zu einzelnen Fähigkeiten.",
            "comments_title": "Kommentare zur Aufnahme",
            "comments_empty": "Zu dieser Aufnahme gibt es keine Kommentare.",
            "loading": "Auswertung wird geladen",
            "error": {
                "not_found": {
                    "title": "Der Link funktioniert nicht",
                    "text": "Die Auswertung ist nicht mehr verfügbar: Der Link ist abgelaufen oder der Versuch wurde widerrufen."
                },
                "expired": {
                    "title": "Die Seite ist abgelaufen",
                    "text": "Öffnen Sie die Auswertung erneut über den Link in Ihrem Lernsystem."
                },
                "generic": {
                    "title": "Die Auswertung kann nicht angezeigt werden",
                    "text": "Bei uns ist etwas schiefgelaufen. Versuchen Sie, den Link erneut zu öffnen."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Vielen Dank!",
                "text": "Das Gespräch ist beendet. Das Ergebnis erscheint in Ihrem Lernsystem, sobald die Auswertung fertig ist. Sie können diese Seite jetzt schließen."
            },
            "aborted": {
                "title": "Das Gespräch hat nicht begonnen",
                "text": "Vor Beginn des Gesprächs ist etwas schiefgelaufen."
            },
            "token_expired": {
                "title": "Die Sitzung ist abgelaufen",
                "text": "Der Zugang zu diesem Gespräch ist nicht mehr gültig."
            },
            "not_found": {
                "title": "Der Link funktioniert nicht",
                "text": "Die Adresse enthält vielleicht einen Tippfehler, oder der Link ist nicht mehr gültig."
            },
            "rate_limited": {
                "title": "Zu viele Versuche",
                "text": "Warten Sie eine Minute, bevor Sie es erneut versuchen."
            },
            "generic": {
                "title": "Gerade kann nicht gestartet werden",
                "text": "Bei uns ist etwas schiefgelaufen."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Das Material ist geschlossen",
                "text": "Dieses Material steht nicht mehr zum Üben zur Verfügung."
            },
            "publication_draft": {
                "title": "Das Material ist noch nicht veröffentlicht",
                "text": "Für dieses Material wurde das Üben noch nicht freigegeben."
            },
            "publication_expired": {
                "title": "Das Material ist abgelaufen",
                "text": "Der Zeitraum, in dem dieses Material geübt werden konnte, ist vorbei."
            },
            "feature_disabled": {
                "title": "Das Material ist geschlossen",
                "text": "Das Üben aus dem Lernsystem ist für Ihre Organisation deaktiviert."
            },
            "connection_disabled": {
                "title": "Das Material ist geschlossen",
                "text": "Die Verbindung zu Ihrem Lernsystem wurde deaktiviert. Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "launch_limit_reached": {
                "title": "Das Limit ist erreicht",
                "text": "Für dieses Material wurde bereits die maximale Anzahl an Gesprächen geführt."
            },
            "daily_budget_exhausted": {
                "title": "Für heute reicht es",
                "text": "Sie haben die Anzahl der pro Tag erlaubten Gespräche erreicht. Versuchen Sie es morgen erneut."
            },
            "attempts_exhausted": {
                "title": "Keine Versuche mehr",
                "text": "Sie haben alle für dieses Material erlaubten Versuche verwendet."
            },
            "quota_exhausted": {
                "title": "Gerade kann nicht gestartet werden",
                "text": "Ihrer Organisation stehen keine Gespräche mehr zur Verfügung. Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "user_limit_reached": {
                "title": "Gerade kann nicht gestartet werden",
                "text": "Ihrer Organisation stehen keine freien Plätze mehr zur Verfügung. Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "scenario_unavailable": {
                "title": "Das Material ist nicht verfügbar",
                "text": "Das Gespräch hinter diesem Material gibt es nicht mehr."
            },
            "assignment_check_unavailable": {
                "title": "Gerade kann nicht gestartet werden",
                "text": "Wir konnten nicht bestätigen, dass Ihnen dieses Material zugewiesen wurde. Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "code_invalid": {
                "title": "Der Link ist nicht mehr gültig",
                "text": "Dieser Link wurde bereits verwendet oder seine Zeit ist abgelaufen."
            },
            "channel_verification_failed": {
                "title": "Das Lernsystem hat nicht geantwortet",
                "text": "Wir konnten die Anfrage bei Ihrem Lernsystem nicht bestätigen."
            },
            "external_system_unavailable": {
                "title": "Das Lernsystem antwortet nicht",
                "text": "Wir konnten im Lernsystem nicht überprüfen, ob Ihnen der Kurs zugewiesen ist. Versuchen Sie es in ein paar Minuten erneut."
            },
            "user_not_found": {
                "title": "Wir konnten Sie nicht identifizieren",
                "text": "Für Sie gibt es hier noch kein Konto, und Ihre Organisation legt es nicht automatisch an. Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "user_unavailable": {
                "title": "Ihr Konto ist deaktiviert",
                "text": "Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "user_deleted": {
                "title": "Ihr Konto ist gelöscht",
                "text": "Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "email_taken_linking_disabled": {
                "title": "Wir konnten Sie nicht identifizieren",
                "text": "Ihre E-Mail-Adresse gehört hier bereits zu einem anderen Konto. Wenden Sie sich an die Person, die Ihnen den Kurs zugewiesen hat."
            },
            "service_role_not_allowed": {
                "title": "Mit diesem Konto kann nicht geübt werden",
                "text": "Administratorkonten nehmen nicht an Übungsgesprächen teil. Nutzen Sie Ihr eigenes Lernkonto."
            },
            "unverified_request": {
                "title": "Wir konnten die Anfrage nicht bestätigen",
                "text": "Ihr Lernsystem hat nicht bestätigt, dass Sie dieses Gespräch gestartet haben."
            }
        },
        "manage": {
            "nav": {
                "group": "Externer Start",
                "publications": "Veröffentlichungen",
                "connections": "LMS-Verbindungen"
            },
            "messages": {
                "error": "Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
                "load_error": "Die Daten konnten nicht geladen werden."
            },
            "connections": {
                "title": "LMS-Verbindungen",
                "subtitle": "Konten von Lernsystemen, aus denen diese Organisation Übungsgespräche startet.",
                "create": "Verbindung hinzufügen",
                "edit": "Bearbeiten",
                "set_credentials": "Zugangsdaten festlegen",
                "empty": "Noch keine Verbindungen.",
                "secret_missing": "Nicht festgelegt",
                "no_expiry": "Läuft nicht ab",
                "headers": {
                    "account": "Konto",
                    "base_url": "Adresse",
                    "client_id": "Client-Kennung",
                    "secret": "Secret",
                    "status": "Status",
                    "expires_at": "Zugangsdaten laufen ab",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Keine Zugangsdaten",
                    "active": "Aktiv",
                    "expired": "Zugangsdaten abgelaufen",
                    "disabled": "Deaktiviert"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Neue Verbindung",
                    "edit_title": "Verbindung",
                    "immutable_hint": "Das Lernsystem und das Konto können nicht geändert werden: Sie legen den Identitätsraum der Lernenden fest. Ein anderes Konto ist eine neue Verbindung.",
                    "lms_label": "Lernsystem",
                    "account_key_label": "Konto",
                    "account_key_hint": "Die Kontokennung im Lernsystem.",
                    "base_url_label": "iSpring-REST-API-Adresse",
                    "base_url_hint": "Zum Beispiel https://api-learn.ispringlearn.ru. Das ist nicht die Adresse des Firmenportals: Dorthin wird das Secret gesendet.",
                    "base_url_https": "Die Adresse muss mit https:// beginnen",
                    "enabled_label": "Verbindung ist aktiv",
                    "enabled_hint": "Eine Verbindung wird nie gelöscht — sie wird deaktiviert. Veröffentlichungen und Starts bleiben in den Listen, aber neue Starts werden abgelehnt und Ergebnisse gehen nicht mehr an das Lernsystem.",
                    "credentials_optional": "Zugangsdaten sind optional. Ohne sie arbeitet die Verbindung im eingeschränkten Modus.",
                    "client_id_label": "Client-Kennung",
                    "secret_label": "Secret",
                    "secret_hint": "Wird verschlüsselt gespeichert. Es kann nie wieder ausgelesen werden — es werden nur die letzten vier Zeichen angezeigt.",
                    "expires_at_label": "Zugangsdaten laufen ab",
                    "expires_at_hint": "Leer lassen, wenn die Zugangsdaten nicht ablaufen."
                },
                "credentials_dialog": {
                    "title": "Zugangsdaten",
                    "lead": "Das neue Secret ersetzt das vorherige. Die Verbindung behält ihre Kennung, und die Links der Lernenden sowie die Starts bleiben unverändert.",
                    "secret_hint": "Das vorherige Secret wird nicht mehr benötigt und kann nicht ausgelesen werden."
                },
                "messages": {
                    "saved": "Verbindung gespeichert",
                    "credentials_saved": "Zugangsdaten gespeichert"
                }
            },
            "publications": {
                "title": "Veröffentlichungen",
                "subtitle": "Szenarien, die für den Start aus einem Lernsystem geöffnet sind.",
                "create": "Neue Veröffentlichung",
                "edit": "Bearbeiten",
                "enable": "Aktivieren",
                "disable": "Deaktivieren",
                "open_journal": "Journal",
                "download_package": "Paket herunterladen",
                "empty": "Noch keine Veröffentlichungen.",
                "no_connections": "Es gibt noch keine Verbindung zu einem Lernsystem. Ein Plattformadministrator richtet sie ein.",
                "no_expiry": "Kein Ablaufdatum",
                "attempts_unlimited": "Unbegrenzt",
                "immutable_hint": "Verbindung, Szenario und Auslieferungskanal können nicht geändert werden: Sie sind fest in das Paket eingebaut, das bereits in das Lernsystem hochgeladen wurde. Alles andere wirkt, ohne das Paket neu zu erstellen.",
                "headers": {
                    "scenario": "Szenario",
                    "connection": "Verbindung",
                    "channel": "Kanal",
                    "status": "Status",
                    "settings": "Einstellungen",
                    "expires_at": "Läuft ab",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Versuche: {value}",
                    "threshold": "Bestehensgrenze: {value}"
                },
                "status": {
                    "draft": "Entwurf",
                    "active": "Aktiv",
                    "disabled": "Deaktiviert"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Nur Status",
                    "status_and_score": "Status und Punktzahl",
                    "status_score_and_review": "Status, Punktzahl und ein Link zur Auswertung"
                },
                "warnings": {
                    "limited_mode": "Eingeschränkter Modus: Punktzahl und Ergebnis erscheinen nicht im Lernsystem, und die Zuweisungsprüfung wird nicht durchgeführt.",
                    "connection_disabled": "Die Verbindung ist deaktiviert: Starts über diese Veröffentlichung werden gar nicht angenommen, bis ein Administrator die Verbindung wieder aktiviert.",
                    "assignment_check_off": "Bei ausgeschaltetem Schalter wird eine erneute Kurszuweisung nicht erkannt.",
                    "no_course_binding": "Die Veröffentlichung ist an keinen Kurs gebunden — die Punktzahl erreicht das Lernsystem nicht."
                },
                "dialog": {
                    "connection_label": "Verbindung",
                    "scenario_label": "Szenario",
                    "channel_label": "Auslieferungskanal",
                    "channel_hint": "In das Paket eingebaut und danach nicht mehr änderbar.",
                    "status_label": "Status",
                    "status_hint": "Eine Veröffentlichung wird nie gelöscht — sie wird deaktiviert. Danach werden neue Starts abgelehnt und noch nicht versendete Ergebnisse storniert.",
                    "settings_section": "Versuchseinstellungen",
                    "attempts_label": "Versuche pro Lernendem",
                    "attempts_unlimited": "Ohne Begrenzung",
                    "daily_budget_label": "Starts pro Tag und Lernendem",
                    "daily_budget_hint": "Schützt das Kontingent: Jedes gestartete Gespräch wird belastet und nie zurückerstattet.",
                    "result_mode_label": "Was an das Lernsystem zurückgeht",
                    "pass_threshold_label": "Bestehensgrenze, 0–100",
                    "result_wait_label": "Wartezeit auf die Auswertung, Stunden",
                    "result_wait_hint": "Danach meldet der Start „kein Ergebnis“.",
                    "launch_limit_label": "Gesamtlimit der Starts",
                    "launch_limit_hint": "Leer lassen für keine Begrenzung.",
                    "assignment_check_label": "Zuweisung im Lernsystem prüfen",
                    "binding_section": "Verknüpfung im Lernsystem",
                    "external_course_label": "Kurs-Kennung",
                    "external_item_label": "Element-Kennung",
                    "expires_label": "Veröffentlichung läuft ab",
                    "expires_hint": "Leer lassen, wenn die Veröffentlichung nicht abläuft."
                },
                "key_dialog": {
                    "title": "Die Veröffentlichung wurde erstellt",
                    "warning": "Der Schlüssel wird nur einmal und nur hier angezeigt. Er kann nirgendwo mehr ausgelesen werden — kopieren Sie ihn jetzt und tragen Sie ihn in die Paketeinstellungen ein. Geht er verloren, müssen Sie eine neue Veröffentlichung erstellen.",
                    "key_label": "Veröffentlichungsschlüssel",
                    "copied": "Kopiert",
                    "package_hint": "Der Schlüssel steckt bereits im Paket, es muss also nirgendwo eingefügt werden. Laden Sie das Paket herunter und laden Sie es in das Lernsystem hoch. Sie können es jederzeit erneut auf der Seite Veröffentlichungen herunterladen."
                },
                "messages": {
                    "saved": "Veröffentlichung gespeichert",
                    "enabled": "Veröffentlichung aktiviert",
                    "disabled": "Veröffentlichung deaktiviert",
                    "download_failed": "Das Paket konnte nicht heruntergeladen werden. Aktualisieren Sie die Seite und versuchen Sie es erneut."
                }
            },
            "journal": {
                "title": "Start-Journal",
                "unknown_scenario": "Szenario nicht verfügbar",
                "back": "Zu den Veröffentlichungen",
                "revoke": "Versuch widerrufen",
                "revoke_confirm": "Diesen Versuch widerrufen? Der Lernende verliert den Zugang zum Gespräch, und noch nicht erfolgte Auslieferungen werden storniert.",
                "retry_delivery": "Erneut versuchen",
                "empty_launches": "Noch keine Starts.",
                "empty_events": "Noch keine Ereignisse.",
                "no_deliveries": "Für diesen Versuch gibt es keine Auslieferungen.",
                "not_held_quota_charged": "Fand nicht statt, Kontingent belastet",
                "relaunches": "Erneute Starts: {value}",
                "last_launch": "letzter Start: {value}",
                "result_deadline": "Warten auf die Auswertung bis {value}",
                "learner_contacts": "Vom Lernsystem gesendete Adresse: {email}. Gestartet von: {ip}",
                "score_passed": "{value} — bestanden",
                "score_failed": "{value} — nicht bestanden",
                "tabs": {
                    "launches": "Versuche",
                    "events": "Ereignisse"
                },
                "headers": {
                    "learner": "Lernende",
                    "user": "Konto",
                    "attempt": "Versuch",
                    "status": "Status",
                    "game": "Gespräch",
                    "started_at": "Gestartet",
                    "actions": " ",
                    "event_type": "Ereignis",
                    "refusal": "Grund",
                    "request_proof": "Anfragenachweis",
                    "ip": "Adresse",
                    "user_agent": "Client",
                    "happened_at": "Wann"
                },
                "launch_status": {
                    "created": "Link ausgestellt",
                    "started": "Läuft",
                    "not_held": "Fand nicht statt",
                    "awaiting_result": "Wartet auf die Auswertung",
                    "result_ready": "Ergebnis übermittelt",
                    "evaluation_failed": "Keine Auswertung",
                    "result_timed_out": "Wartezeit abgelaufen",
                    "assignment_changed": "Zuweisung geändert",
                    "revoked": "Widerrufen"
                },
                "delivery": {
                    "version": "Version",
                    "status": "Status",
                    "outcome": "Ausgang",
                    "result": "Ergebnis",
                    "score": "Punktzahl",
                    "attempts": "Versuche",
                    "last_attempt": "Letzter Versuch",
                    "external_state": "Status im Lernsystem"
                },
                "delivery_status": {
                    "pending": "In Warteschlange",
                    "in_progress": "Wird gesendet",
                    "done": "Fertig",
                    "needs_attention": "Erfordert Aufmerksamkeit"
                },
                "delivery_outcome": {
                    "accepted": "Angenommen",
                    "confirmed": "Bestätigt",
                    "rejected_by_external": "Abgelehnt",
                    "retry": "Wiederholung geplant",
                    "cancelled": "Storniert",
                    "assignment_changed": "Zuweisung geändert"
                },
                "result": {
                    "passed": "Bestanden",
                    "failed": "Nicht bestanden",
                    "not_held": "Fand nicht statt",
                    "no_result": "Kein Ergebnis"
                },
                "refusal": {
                    "publication_disabled": "Veröffentlichung deaktiviert",
                    "publication_draft": "Veröffentlichung ist Entwurf",
                    "publication_expired": "Veröffentlichung abgelaufen",
                    "feature_disabled": "Externer Start deaktiviert",
                    "connection_disabled": "Verbindung deaktiviert",
                    "launch_limit_reached": "Startlimit erreicht",
                    "daily_budget_exhausted": "Tagesbudget erschöpft",
                    "attempts_exhausted": "Versuche erschöpft",
                    "quota_exhausted": "Kontingent der Organisation erschöpft",
                    "user_limit_reached": "Keine freien Plätze mehr",
                    "scenario_unavailable": "Szenario nicht verfügbar",
                    "assignment_check_unavailable": "Zuweisungsprüfung nicht verfügbar",
                    "code_invalid": "Link bereits verwendet oder abgelaufen",
                    "channel_verification_failed": "Lernsystem hat Anfrage nicht bestätigt",
                    "external_system_unavailable": "Lernsystem hat nicht auf die Zuweisungsprüfung geantwortet",
                    "user_not_found": "Kein Konto für diesen Lernenden",
                    "user_unavailable": "Konto des Lernenden deaktiviert",
                    "user_deleted": "Konto des Lernenden gelöscht",
                    "email_taken_linking_disabled": "E-Mail gehört zu einem anderen Konto",
                    "service_role_not_allowed": "Dienstkonto kann nicht üben",
                    "unverified_request": "Anfrage nicht bestätigt"
                },
                "event_type": {
                    "launch_refused": "Start abgelehnt",
                    "exchange_refused": "Link abgelehnt",
                    "exchange_succeeded": "Link verwendet"
                },
                "request_proof": {
                    "unverified": "Nicht bestätigt",
                    "assignment_verified": "Zuweisung bestätigt"
                },
                "messages": {
                    "retry_queued": "Wiederholung eingereiht",
                    "revoked": "Versuch widerrufen"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Training",
            "interview": "Interview"
        },
        "load": {
            "loading": "Sitzung wird geladen…",
            "failed": "Die Sitzung konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
            "scenarioFailed": "Das Szenario konnte nicht geladen werden",
            "scenarioRetry": "Erneut versuchen"
        },
        "leave": {
            "confirm": "Das Gespräch läuft noch. Die Seite zu verlassen beendet es nicht, und die Zeit läuft weiter. Seite verlassen?",
            "confirmEnd": "Das Gespräch läuft noch. Wenn Sie die Seite verlassen, wird es beendet und anhand dessen bewertet, was Sie bis dahin geschafft haben. Verlassen?"
        },
        "elsewhere": {
            "interviewTitle": "Das Interview ist in einem anderen Tab geöffnet",
            "interviewText": "Das Interview läuft in einem anderen Tab oder auf einem anderen Gerät weiter. Setzen Sie es dort fort — diesen Tab können Sie schließen.",
            "conversationTitle": "Das Gespräch ist in einem anderen Tab geöffnet",
            "conversationText": "Das Gespräch läuft in einem anderen Tab oder auf einem anderen Gerät weiter. Setzen Sie es dort fort — diesen Tab können Sie schließen."
        },
        "prep": {
            "header": {
                "backToSessions": "Zu den Sitzungen",
                "themeToggleAriaLabel": "Design wechseln"
            },
            "scenario": {
                "sectionLabel": "Szenario",
                "competenceLabel": "Bewertete Kompetenz",
                "gameNumber": "Sitzung #{number}",
                "duration": "{minutes} Min.",
                "readFull": "Vollständig lesen",
                "generalLabel": "Allgemeine Informationen",
                "playerLabel": "Informationen für Sie"
            },
            "selfCamera": {
                "previewLabel": "Vorschau Ihrer Kamera",
                "off": "Kamera ist aus"
            },
            "notes": {
                "empty": "Leer"
            },
            "start": {
                "button": "Sitzung starten",
                "interviewButton": "Interview starten",
                "resumeButton": "Zurück zum Gespräch",
                "resumeHint": "Das Gespräch läuft bereits — die Zeit läuft weiter."
            }
        },
        "equipment": {
            "status": {
                "checking": "Geräte werden geprüft",
                "waiting": "Warten auf Erlaubnis",
                "denied": "Zugriff verweigert",
                "busy": "Gerät belegt",
                "noCamera": "Keine Kamera",
                "missing": "Kein Mikrofon",
                "dismissed": "Zugriff nicht erteilt",
                "ready": "Geräte bereit"
            },
            "checking": {
                "title": "Wir prüfen Ihr Mikrofon und Ihre Kamera…"
            },
            "waiting": {
                "title": "Mikrofonzugriff erlauben",
                "cameraTitle": "Kamerazugriff erlauben",
                "description": "Die Berechtigungsanfrage des Browsers ist bereits geöffnet. Ohne Mikrofon kann das Gespräch nicht beginnen."
            },
            "denied": {
                "title": "Der Browser blockiert das Mikrofon",
                "cameraTitle": "Der Browser blockiert die Kamera",
                "description": "Ihr Browser hat sich die Blockierung gemerkt. Erlauben Sie den Mikrofonzugriff in den Website-Einstellungen und laden Sie die Seite neu.",
                "cameraDescription": "Ihr Browser hat sich die Blockierung gemerkt. Erlauben Sie den Kamerazugriff in den Website-Einstellungen und laden Sie die Seite neu.",
                "showInstructions": "So geht's",
                "hideInstructions": "Ausblenden",
                "chromeEdge": {
                    "browser": "Chrome und Edge",
                    "text": "Klicken Sie auf das Schloss-Symbol links neben der Adressleiste, öffnen Sie „Website-Einstellungen“, erlauben Sie „Mikrofon“ und laden Sie die Seite neu."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Öffnen Sie das Safari-Menü → „Einstellungen für diese Website“, erlauben Sie „Mikrofon“ und laden Sie die Seite neu."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Klicken Sie auf das Mikrofonsymbol in der Adressleiste, entfernen Sie die Blockierung für diese Website und laden Sie die Seite neu."
                },
                "system": {
                    "title": "Ihr System blockiert den Zugriff des Browsers auf das Mikrofon",
                    "cameraTitle": "Ihr System blockiert den Zugriff des Browsers auf die Kamera",
                    "macos": "macOS: Systemeinstellungen → Datenschutz & Sicherheit → Mikrofon (oder Kamera) → aktivieren Sie Ihren Browser und starten Sie ihn neu.",
                    "windows": "Windows: Einstellungen → Datenschutz und Sicherheit → Mikrofon (oder Kamera) → erlauben Sie den Zugriff für Apps und Ihren Browser, und klicken Sie dann auf „Erneut versuchen“."
                }
            },
            "busy": {
                "title": "Das Mikrofon wird von einer anderen App verwendet",
                "cameraTitle": "Die Kamera wird von einer anderen App verwendet",
                "description": "Meist läuft im Hintergrund noch ein Anruf. Beenden Sie ihn und klicken Sie auf „Erneut versuchen“.",
                "retry": "Erneut versuchen"
            },
            "noCamera": {
                "title": "Keine Kamera",
                "description": "Sie werden gehört, aber nicht gesehen.",
                "requiredByScenario": "Dieses Gespräch erfordert eine Kamera. Schließen Sie eine an, um fortzufahren."
            },
            "missing": {
                "title": "Kein Mikrofon gefunden",
                "description": "Schließen Sie ein Mikrofon an und klicken Sie auf „Erneut versuchen“. Ohne Mikrofon kann das Gespräch nicht beginnen."
            },
            "dismissed": {
                "title": "Mikrofonzugriff wurde nicht erteilt",
                "cameraTitle": "Kamerazugriff wurde nicht erteilt",
                "description": "Das Browserfenster wurde ohne Antwort geschlossen. Klicken Sie auf „Erneut versuchen“ und erlauben Sie den Zugriff."
            },
            "ready": {
                "title": "Geräte bereit"
            },
            "micLabel": "Mikrofon",
            "cameraLabel": "Kamera",
            "chooseMic": "Mikrofon auswählen",
            "chooseCamera": "Kamera auswählen",
            "micLevelHint": "Sagen Sie etwas",
            "speakerValue": "Lautsprecher: {name}",
            "configure": "Einrichten",
            "dialog": {
                "title": "Geräte",
                "lockedDuringConversation": "Geräte können während des Gesprächs nicht geändert werden.",
                "micSelectLabel": "Mikrofon",
                "cameraSelectLabel": "Kamera",
                "speakerSelectLabel": "Lautsprecher",
                "noCameraOption": "Keine Kamera",
                "record": "3 Sekunden aufnehmen",
                "recording": "Aufnahme läuft…",
                "recordFailed": "Aufnahme nicht möglich. Versuchen Sie es erneut.",
                "listen": "Abspielen",
                "playing": "Wiedergabe…",
                "done": "Fertig",
                "closeAriaLabel": "Dialog schließen"
            },
            "unnamed": {
                "microphone": "Mikrofon {number}",
                "camera": "Kamera {number}",
                "speaker": "Lautsprecher {number}"
            },
            "cameraWarmup": {
                "preview": "Kamera wird eingeschaltet",
                "title": "Mikrofon bereit",
                "description": "Die Kamera zieht nach – meist in ein, zwei Sekunden.",
                "slowHint": "Kamera schaltet sich nicht ein? Wählen Sie unter „Einrichten“ eine andere aus."
            }
        },
        "recording": {
            "videoAndAudio": "Das Gespräch und das Video werden aufgezeichnet.",
            "audioOnly": "Das Gespräch wird aufgezeichnet.",
            "accessSelfAndEvaluators": "Die Aufnahme steht Ihnen und denjenigen zur Verfügung, die Ihre Arbeit bewerten.",
            "accessEvaluators": "Die Aufnahme steht denjenigen zur Verfügung, die Ihre Arbeit bewerten."
        },
        "scenario": {
            "video": "Video vom Szenario-Autor"
        },
        "notes": {
            "title": "Notizen zur Sitzung",
            "placeholder": "Was Sie üben möchten, vorbereitete Formulierungen",
            "saving": "Wird gespeichert…",
            "saved": "Gespeichert",
            "saveError": "Speichern nicht möglich",
            "visibility": "Die Notizen sind für Sie und für alle sichtbar, die die Sitzung bewerten.",
            "unsupported": "Diese Notizen enthalten Elemente, die hier nicht bearbeitet werden können. Sie bleiben unverändert erhalten."
        },
        "stage": {
            "agentState": {
                "speaking": "Spricht",
                "listening": "Hört zu",
                "thinking": "Denkt nach"
            },
            "micOffWarning": "Mikrofon ist aus — Ihr Gesprächspartner kann Sie nicht hören",
            "micOnAriaLabel": "Mikrofon ausschalten",
            "micOffAriaLabel": "Mikrofon einschalten",
            "micOff": "Mikrofon aus",
            "micOnAnnouncement": "Mikrofon an",
            "captionsLabel": "Untertitel",
            "captionsOnAriaLabel": "Untertitel ausblenden",
            "captionsOffAriaLabel": "Untertitel einblenden",
            "talkBalance": {
                "title": "Redeanteil",
                "you": "Sie",
                "interlocutor": "Gesprächspartner"
            },
            "connectionQuality": {
                "excellent": "Ausgezeichnete Verbindung",
                "good": "Gute Verbindung",
                "poor": "Schwache Verbindung",
                "unknown": "Verbindungsqualität unbekannt"
            },
            "selfCameraLabel": "Sie",
            "timeWarning": {
                "lastMinute": "Noch eine Minute — Zeit zum Abschließen",
                "finalSeconds": "15 Sekunden — beenden Sie Ihren Gedanken"
            },
            "timeUp": {
                "title": "Die Zeit ist um",
                "text": "Das Gespräch endet von selbst; es kann nicht verlängert werden.",
                "closing": "Gespräch wird beendet…"
            },
            "voiceOnly": "Sprachmodus — dieses Szenario hat kein Video",
            "interlocutorConnecting": {
                "title": "Gesprächspartner verbindet sich",
                "hint": "Meist 2–4 Sekunden"
            },
            "layout": {
                "label": "Nebeneinander",
                "sideTitle": "Nebeneinander anordnen",
                "focusTitle": "Gesprächspartner groß anzeigen"
            }
        },
        "panels": {
            "scenario": "Szenario",
            "transcript": "Transkript",
            "transcriptEmpty": "Fertige Antworten erscheinen hier.",
            "notes": "Notizen",
            "characterMemoryTab": "Was sich die Figur merkt",
            "openAriaLabel": "Panel „{panel}“ öffnen",
            "closeAriaLabel": "Panel „{panel}“ schließen"
        },
        "sound": {
            "label": "Ton",
            "volumeLabel": "Lautstärke",
            "speakerLabel": "Lautsprecher"
        },
        "end": {
            "button": "Beenden",
            "confirmTitle": "Gespräch beenden?",
            "elapsed": "Verstrichene Zeit: {elapsed} von {total}.",
            "partialEvaluationNotice": "Das Gespräch wird anhand dessen bewertet, was Sie bis dahin geschafft haben.",
            "continue": "Fortfahren",
            "notSent": "Das Gespräch endet zeitgesteuert: Der Server hat nicht auf die Beendigungsanfrage geantwortet."
        },
        "wait": {
            "title": "Gespräch wird vorbereitet",
            "hint": "Das dauert in der Regel 1–3 Minuten. Schließen Sie die Seite nicht — wir starten automatisch.",
            "nextTry": "Nächster Versuch in {time}",
            "trying": "Start wird versucht…",
            "retrying": "Noch nicht geklappt. Neuer Versuch in {time}",
            "cancel": "Abbrechen",
            "failed": {
                "title": "Das Gespräch konnte nicht gestartet werden",
                "text": "Zurzeit sind keine Plätze frei. Ihre Mikrofon- und Kameraeinstellungen sind gespeichert — versuchen Sie es in ein paar Minuten erneut.",
                "retry": "Erneut versuchen"
            }
        },
        "connection": {
            "reconnecting": "Verbindung verloren, Wiederverbindung läuft…",
            "restored": "Verbindung wiederhergestellt",
            "failed": "Verbindung konnte nicht wiederhergestellt werden",
            "retry": "Erneut versuchen"
        },
        "hotkeys": {
            "title": "Tastenkombinationen",
            "showHintAriaLabel": "Tastenkombinationen anzeigen",
            "micToggle": "Mikrofon umschalten",
            "scenarioPanel": "Szenario: Panel öffnen und schließen",
            "transcriptPanel": "Transkript",
            "notesPanel": "Notizen",
            "captionsToggle": "Untertitel umschalten",
            "closeTopLayer": "Panel, Popover oder Dialog schließen",
            "endConfirm": "Beenden — öffnet die Bestätigung",
            "showHint": "Diesen Hinweis anzeigen"
        },
        "intro": {
            "candidate": {
                "greeting": "Guten Tag, {name}!",
                "leadWithVacancy": "{organization} lädt Sie zu einem Interview mit einem virtuellen Gesprächspartner für die Stelle „{vacancy}“ ein.",
                "duration": "Das Interview dauert etwa {minutes} Minuten.",
                "requirementsTitle": "Was Sie benötigen",
                "requirementMic": "Ein funktionierendes Mikrofon, idealerweise ein Headset",
                "requirementCameraRequired": "Kamera eingeschaltet: Sie ist für dieses Interview erforderlich",
                "requirementCameraOptional": "Eine Kamera ist nicht erforderlich, macht das Gespräch aber natürlicher",
                "requirementBrowser": "Ein Computer mit aktuellem Chrome, Edge oder Safari",
                "requirementNetwork": "Eine stabile Internetverbindung und ein ruhiger Ort, an dem Sie ungestört sind",
                "consentTextLabel": "Einwilligungstext",
                "consentAccept": "Ich habe den Text gelesen und stimme der Verarbeitung meiner personenbezogenen Daten zu",
                "next": "Weiter"
            },
            "launch": {
                "title": "Übungsgespräch",
                "lead": "Gleich sprechen Sie mit einem virtuellen Gesprächspartner. Das Gespräch wird aufgezeichnet und ausgewertet, das Ergebnis geht an Ihr Lernsystem zurück.",
                "requirementsTitle": "Was Sie benötigen",
                "requirementMic": "Ein funktionierendes Mikrofon, idealerweise ein Headset",
                "requirementCamera": "Eine Kamera ist nicht erforderlich, macht das Gespräch aber lebendiger",
                "requirementBrowser": "Ein Computer mit aktuellem Chrome, Edge oder Safari",
                "requirementNetwork": "Eine stabile Internetverbindung und ein ruhiger Ort, an dem Sie ungestört sind",
                "start": "Starten"
            }
        },
        "finished": {
            "candidate": {
                "title": "Vielen Dank!",
                "text": "Das Interview ist beendet. Das Ergebnis geht an den Recruiter, der sich bei Ihnen melden wird. Sie können diese Seite jetzt schließen."
            },
            "launch": {
                "title": "Vielen Dank!",
                "text": "Das Gespräch ist beendet. Das Ergebnis erscheint in Ihrem Lernsystem, sobald die Auswertung fertig ist. Sie können diese Seite jetzt schließen."
            }
        },
        "closeDialogAriaLabel": "Dialog schließen"
    },
    "loopAvatars": {
        "title": "Loop-Avatare",
        "upload": "Avatar hochladen",
        "newVersion": "Neue Version",
        "newVersionHint": "„{name}“, aktuelle Version {version}. Das neue Paket ersetzt die Videos in allen Profilen mit diesem Avatar.",
        "edit": "Avatar bearbeiten",
        "delete": "Avatar löschen",
        "empty": "Noch keine Avatare",
        "headers": {
            "poster": "Vorschaubild",
            "name": "Name",
            "gender": "Geschlecht",
            "emotion": "Emotion",
            "visibility": "Sichtbarkeit",
            "version": "Version",
            "profiles": "Profile"
        },
        "gender": {
            "male": "Männlich",
            "female": "Weiblich"
        },
        "emotion": {
            "calm": "Ruhig",
            "friendly": "Freundlich",
            "strict": "Streng"
        },
        "visibility": {
            "all": "Alle Unternehmen"
        },
        "fields": {
            "package": "Avatar-Paket (.zip)"
        },
        "packageHint": "ZIP bis 100 MB mit manifest.json, listen.mp4, talk.mp4, transitions.json und poster.jpg",
        "validation": {
            "packageTooLarge": "Das Paket darf 100 MB nicht überschreiten"
        },
        "errors": {
            "requestFailed": "Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut."
        },
        "confirmDetach": "Profile, die getrennt werden: {count}. Sie wechseln zum Foto. Speichern?",
        "confirmDelete": "Avatar „{name}“ löschen?",
        "confirmDeleteWithProfiles": "Avatar „{name}“ wird in Profilen verwendet: {count}. Sie wechseln zum Foto. Löschen?"
    },
    "ttsVoices": {
        "title": "TTS-Stimmen",
        "create": "Stimme hinzufügen",
        "edit": "Stimme bearbeiten",
        "delete": "Stimme löschen",
        "replaceSample": "Hörprobe ersetzen",
        "replaceSampleHint": "„{name}“, aktuelle Version der Hörprobe {version}. Die neue Hörprobe wird in allen Profilen mit dieser Stimme abgespielt.",
        "empty": "Noch keine Stimmen",
        "play": "Hörprobe anhören",
        "stop": "Stopp",
        "headers": {
            "name": "Name",
            "provider": "Anbieter",
            "externalId": "Stimmen-ID",
            "gender": "Geschlecht",
            "languages": "Sprachen",
            "visibility": "Sichtbarkeit",
            "sample": "Hörprobe",
            "profiles": "Profile"
        },
        "gender": {
            "male": "Männlich",
            "female": "Weiblich"
        },
        "visibility": {
            "all": "Alle Unternehmen"
        },
        "fields": {
            "sample": "Stimmprobe",
            "speed": "Sprechgeschwindigkeit"
        },
        "sampleHint": "MP3, MP4 oder M4A bis 5 MB",
        "sampleOptionalHint": "Optional — die Hörprobe wird mit der Stimme anhand ihrer ID erzeugt. MP3, MP4 oder M4A bis 5 MB",
        "synthesizeSample": "Neu erzeugen",
        "speedChangedHint": "Erzeugen Sie die Stimmprobe neu, um die neue Geschwindigkeit zu hören.",
        "speedSamplePromptTitle": "Geschwindigkeit geändert",
        "speedSamplePrompt": "Die Stimmprobe klingt noch mit der vorherigen Geschwindigkeit. Möchten Sie sie neu erzeugen? Die aktuelle Probe wird ersetzt.",
        "saveAndSynthesize": "Speichern und erzeugen",
        "saveOnly": "Nur speichern",
        "validation": {
            "sampleTooLarge": "Die Hörprobe darf 5 MB nicht überschreiten"
        },
        "errors": {
            "requestFailed": "Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "sampleUnavailable": "Die Hörprobe konnte nicht abgespielt werden"
        },
        "confirmDetach": "Profile, die getrennt werden: {count}. Sie wechseln zur Stimme der Verbindung. Speichern?",
        "confirmDelete": "Stimme „{name}“ löschen?",
        "confirmDeleteWithProfiles": "Stimme „{name}“ wird in Profilen verwendet: {count}. Sie wechseln zur Stimme der Verbindung. Löschen?",
        "picker": {
            "none": "Standardstimme",
            "empty": "Im Katalog gibt es keine Stimmen für dieses Geschlecht",
            "loadError": "Stimmen konnten nicht geladen werden",
            "playSample": "Hörprobe anhören: {name}",
            "stopSample": "Hörprobe stoppen: {name}",
            "sampleUnavailable": "Hörprobe nicht verfügbar"
        }
    },
    "realtimeAvatars": {
        "title": "Live-Avatare",
        "create": "Avatar hinzufügen",
        "edit": "Avatar bearbeiten",
        "delete": "Avatar löschen",
        "preview": "Vorschau ansehen",
        "empty": "Noch keine Avatare",
        "headers": {
            "poster": "Titelbild",
            "name": "Name",
            "provider": "Anbieter",
            "externalId": "Avatar-ID",
            "gender": "Geschlecht",
            "visibility": "Sichtbarkeit",
            "profiles": "Profile",
            "models": "Anam-Modelle"
        },
        "gender": {
            "male": "Männlich",
            "female": "Weiblich"
        },
        "visibility": {
            "all": "Alle Unternehmen"
        },
        "nameHint": "Optional — es wird der Name von Anam verwendet",
        "externalIdHint": "Wenn Sie die ID ändern, werden Titelbild und Vorschau erneut von Anam geladen",
        "errors": {
            "requestFailed": "Anfrage fehlgeschlagen. Bitte versuchen Sie es erneut.",
            "previewUnavailable": "Die Vorschau konnte nicht abgespielt werden"
        },
        "confirmDetach": "Profile, die getrennt werden: {count}. Sie wechseln zum Foto. Speichern?",
        "confirmDelete": "Avatar „{name}“ löschen?",
        "confirmDeleteWithProfiles": "Avatar „{name}“ wird in Profilen verwendet: {count}. Sie wechseln zum Foto. Löschen?",
        "picker": {
            "label": "Live-Avatare",
            "empty": "Für dieses Profil sind keine Live-Avatare verfügbar",
            "emptyFiltered": "Keine Live-Avatare dieses Geschlechts",
            "loadError": "Live-Avatare konnten nicht geladen werden"
        }
    },
    "aiProfileAppearance": {
        "label": "Erscheinungsbild",
        "photo": "Eigenes Foto",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Maskottchen",
        "filterGender": "Geschlecht",
        "filterEmotion": "Emotion",
        "avatarsLabel": "Avatare",
        "avatarRequired": "Wählen Sie einen Avatar",
        "liveRequired": "Wählen Sie einen Live-Avatar",
        "livePlaceholder": "Hier erscheint Ihr Live-Avatar",
        "empty": "Für dieses Profil sind keine Avatare verfügbar",
        "emptyFiltered": "Keine Avatare entsprechen den Filtern",
        "loadError": "Avatare konnten nicht geladen werden",
        "playPreview": "Vorschau abspielen: {name}",
        "pausePreview": "Vorschau pausieren: {name}"
    },
    "emailStopList": {
        "title": "E-Mail-Sperrliste",
        "description": "An diese Adressen und Domains werden keine E-Mails gesendet. Ein Domain-Eintrag gilt für alle Adressen dieser Domain, aber nicht für ihre Subdomains.",
        "searchPlaceholder": "Nach Adresse oder Domain suchen",
        "allReasons": "Alle Gründe",
        "add": "Hinzufügen",
        "addTitle": "Adresse oder Domain sperren",
        "empty": "Die Sperrliste ist leer",
        "editNote": "Notiz bearbeiten",
        "headers": {
            "type": "Typ",
            "value": "Adresse oder Domain",
            "reason": "Grund",
            "providerReply": "Antwort des Mailservices",
            "note": "Notiz",
            "author": "Hinzugefügt von",
            "createdAt": "Hinzugefügt am",
            "blockedCount": "Gestoppte E-Mails",
            "lastBlockedAt": "Zuletzt gestoppt"
        },
        "type": {
            "address": "Adresse",
            "domain": "Domain"
        },
        "reason": {
            "manual": "Manuell hinzugefügt",
            "providerRejected": "Vom Mailservice abgelehnt"
        },
        "author": {
            "system": "System"
        },
        "fields": {
            "value": "Adresse oder Domain",
            "valueHint": "Geben Sie eine vollständige Adresse oder nur eine Domain ein. Eine Domain sperrt alle ihre Adressen, aber nicht die Subdomains.",
            "note": "Notiz"
        },
        "errors": {
            "requestFailed": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
        },
        "unblock": {
            "action": "Entsperren",
            "confirm": "{value} entsperren?",
            "resultTitle": "Ergebnis der Entsperrung",
            "result": {
                "removedEverywhere": "Entsperrt. Der Mailservice hat diese Adresse nicht in seiner Sperrliste, E-Mails werden wieder gesendet.",
                "removedLocally": "Domain entsperrt. Adressen dieser Domain mit eigenem Eintrag bleiben gesperrt.",
                "providerNotConfigured": "Nur der Eintrag der Plattform wurde entfernt: Die Verbindung zum Mailservice ist nicht eingerichtet, daher wurde dessen Sperrliste nicht geprüft.",
                "providerUnavailable": "Der Mailservice ist nicht erreichbar, versuchen Sie es später erneut. Die Adresse ist weiterhin gesperrt.",
                "stillListedAtProvider": "Die Adresse steht in der Sperrliste des Mailservices. Entfernen Sie sie im Panel des Mailservices und klicken Sie dann auf „Erneut entsperren“. Wenn die Adresse im Panel nicht angezeigt wird, steht sie in der globalen Sperrliste des Services und kann dort nicht entfernt werden."
            },
            "openPanel": "Panel des Mailservices öffnen",
            "panelPath": "So entfernen Sie sie: Panel des Mailservices → Products → Email Service → Ihre Ressource → Tab Stop Lists.",
            "retry": "Erneut entsperren"
        },
        "suggestions": {
            "text": "Die Domain {domain} hat {count} gesperrte Adressen. Die ganze Domain sperren?",
            "block": "Domain sperren",
            "confirm": "Die Domain {domain} sperren? E-Mails an alle ihre Adressen werden dann nicht mehr gesendet. Subdomains sind nicht betroffen, die Einträge für einzelne Adressen bleiben bestehen."
        },
        "check": {
            "title": "Adresse prüfen",
            "hint": "Zeigt, ob E-Mails an die Adresse von der Plattform oder vom Mailservice blockiert werden",
            "placeholder": "E-Mail-Adresse",
            "submit": "Prüfen",
            "resultFor": "Ergebnis für {email}",
            "platform": "Sperrliste der Plattform",
            "platformListed": "Ja — Eintrag „{value}“",
            "provider": "Sperrliste des Mailservices",
            "listed": "Ja",
            "notListed": "Nein",
            "providerReasons": "Vom Mailservice genannte Gründe:",
            "providerNotConfigured": "Die Verbindung zum Mailservice ist nicht eingerichtet",
            "providerUnavailable": "Der Mailservice ist nicht erreichbar, versuchen Sie es später erneut"
        }
    }
}
